var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _path7, _path8, _path9, _path10, _path11, _path12, _g4, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _rect2, _rect3, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g5, _g6, _g7, _path34, _path35, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamionVl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134.808,
    height: 78,
    viewBox: "0 0 134.808 56.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -340.164, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#030301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -333.623, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0f0f0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161615"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -480.58, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#cacac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#b8b8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#9f9f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#828280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#7f7f7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#787876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#6b6b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#585856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#4f4f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#545452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#60605e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#646463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#121210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#242423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#30302f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.507,
    cy: 1.141,
    r: 0.689,
    gradientTransform: "matrix(-0.599, 0, 0, 1, -184.858, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#141413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#191918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -338.771, 59.527)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#292927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#222220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#161615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -338.83, 59.537)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#353534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -510.903, 89.772)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#afafae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#a4a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#797978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#5c5c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#595957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#525250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#454543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#323230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#292927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#2e2e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#3a3a38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#3e3e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.502,
    cy: 0.5,
    r: 0.499,
    gradientTransform: "matrix(-0.952, 0.341, 0.345, 0.94, -505.247, 88.212)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#636362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#787877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#80807f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.941, 0.341, 0.341, 0.94, -464.665, 81.626)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#a5a5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#a9a9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#c5c5c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1259.186,
    y1: -558.075,
    x2: 1260.186,
    y2: -558.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50575c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10100f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1824.852,
    y1: -808.476,
    x2: 1825.852,
    y2: -808.476,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50575c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1259.739,
    y1: -556.73,
    x2: 1260.739,
    y2: -556.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1826.366,
    y1: -806.544,
    x2: 1827.367,
    y2: -806.544,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1260.323,
    y1: -552.987,
    x2: 1261.323,
    y2: -552.987,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1826.557,
    y1: -801.507,
    x2: 1827.557,
    y2: -801.507,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1260.432,
    y1: -552.176,
    x2: 1261.432,
    y2: -552.176,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1826.192,
    y1: -800.364,
    x2: 1827.191,
    y2: -800.364,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1260.062,
    y1: -555.532,
    x2: 1261.062,
    y2: -555.532,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1825.807,
    y1: -804.688,
    x2: 1826.808,
    y2: -804.688,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -4465.043, 784.673)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -124.791,
    y1: 0.105,
    x2: -124.791,
    y2: 0.981,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#6d6d6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#8a8a88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#a0a09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.922, -0.387, -0.387, 0.922, -346.147, -69.714)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -353.489, 0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, -509.172, 0)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.507,
    cy: 1.141,
    r: 0.689,
    gradientTransform: "matrix(-0.599, 0, 0, 1, -196.608, 0)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -358.999, 63.081)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -359.054, 63.091)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -540.824, 95.029)",
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.502,
    cy: 0.5,
    r: 0.499,
    gradientTransform: "matrix(-0.952, 0.341, 0.345, 0.94, -534.831, 93.378)",
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.941, 0.341, 0.341, 0.94, -491.871, 86.405)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1253.928,
    y1: -589.694,
    x2: 1254.928,
    y2: -589.694,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1816.657,
    y1: -854.27,
    x2: 1817.657,
    y2: -854.27,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1254.179,
    y1: -588.31,
    x2: 1255.179,
    y2: -588.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1817.775,
    y1: -852.358,
    x2: 1818.775,
    y2: -852.358,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1254.76,
    y1: -584.507,
    x2: 1255.76,
    y2: -584.507,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1818.51,
    y1: -847.329,
    x2: 1819.51,
    y2: -847.329,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1255.21,
    y1: -583.883,
    x2: 1256.211,
    y2: -583.883,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1817.703,
    y1: -846.172,
    x2: 1818.702,
    y2: -846.172,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1254.513,
    y1: -587.154,
    x2: 1255.513,
    y2: -587.154,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1816.641,
    y1: -851.04,
    x2: 1817.641,
    y2: -851.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.94, 0.341, 0.341, 0.94, -4727.029, 830.655)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -132.534,
    y1: 0.105,
    x2: -132.534,
    y2: 0.981,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 0.546,
    cy: 0.911,
    r: 7.471,
    gradientTransform: "matrix(-0.056, 0, 0, 1, -88.852, 0)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2458.341,
    y1: 0.5,
    x2: 2459.341,
    y2: 0.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2459.009,
    y1: 0.5,
    x2: 2460.009,
    y2: 0.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -20.288,
    y1: 0.997,
    x2: -20.288,
    y2: -0.004,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93938e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#9e9f9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#acaeaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#b4b8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#babdb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cccecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#e0e0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#e0e1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#e0e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#d5d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -20.142,
    y1: 0.997,
    x2: -20.142,
    y2: -0.004,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#efebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#fafafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 0.5,
    cy: 0.9,
    r: 0.888,
    gradientTransform: "matrix(-0.559, 0, 0, 1, -120.899, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -126.109,
    y1: 0.97,
    x2: -126.109,
    y2: 0.011,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -235.411,
    y1: 0.49,
    x2: -234.404,
    y2: 0.513,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#0b0e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#2e3436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#5b5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#606463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#464644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -342.043,
    y1: 0.933,
    x2: -342.043,
    y2: 0.163,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#5c5c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#8d8d8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#b6b6b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -237.031,
    y1: 0.447,
    x2: -236.028,
    y2: 0.636,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#a5a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#bbbab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#e6e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -353.532,
    y1: 0.503,
    x2: -353.259,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93927e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#aead9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#cbcac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#e2e1dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#f2f2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -64.979,
    y1: 0.911,
    x2: -64.979,
    y2: 0.027,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -187.056,
    y1: 0.911,
    x2: -187.056,
    y2: 0.027,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -407.291,
    y1: 0.915,
    x2: -407.267,
    y2: -0.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -414.943,
    y1: 0.989,
    x2: -414.943,
    y2: -0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#9aa2a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#bfc4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#e1e4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -4116.749,
    y1: 0.5,
    x2: -4115.916,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89928f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#a4aba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#cbcfcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e7e9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 302.436,
    y1: 26.233,
    x2: 303.437,
    y2: 26.233,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#cacac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#b8b8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#9f9f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 302.412,
    y1: 25.966,
    x2: 303.306,
    y2: 26.402,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#cacac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#b8b8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#9f9f9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#7f7f7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5a57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 296.416,
    y1: 26.409,
    x2: 297.417,
    y2: 26.409,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 2668.625,
    y1: 73.232,
    x2: 2669.576,
    y2: 73.232,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 547.16,
    y1: 63.712,
    x2: 548.127,
    y2: 63.712,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -2381.799,
    y1: 73.767,
    x2: -2380.524,
    y2: 73.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -276.62,
    y1: 28.721,
    x2: -275.611,
    y2: 28.721,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -892.643,
    y1: 0.5,
    x2: -891.643,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1259.71,
    y1: 0.5,
    x2: 1260.71,
    y2: 0.5,
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -41.331,
    y1: 0.911,
    x2: -41.331,
    y2: 0.027,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 379.422,
    y1: 0.911,
    x2: 379.422,
    y2: 0.027,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -116.725,
    y1: 0.969,
    x2: -115.858,
    y2: 0.181,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#0b0e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#2e3436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#5b5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#444442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#30302e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -125.106,
    y1: 0.5,
    x2: -124.106,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#637771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a19d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -20471.957,
    y1: 0.5,
    x2: -20470.957,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 32478.334,
    y1: 0.5,
    x2: 32479.334,
    y2: 0.5,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 0.674,
    cy: 0.5,
    r: 0.832,
    gradientTransform: "translate(-0.149)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 392.774,
    y1: 0.98,
    x2: 392.774,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.029,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#060605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#171716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#353534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -28.053,
    y1: 1.022,
    x2: -28.053,
    y2: 0.094,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1029.121,
    y1: -29.363,
    x2: 1029.121,
    y2: -29.37,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#898b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#a6a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1028.158,
    y1: -29.355,
    x2: 1028.158,
    y2: -29.361,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeb4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#b7bcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#b9bebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#d2d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#e6e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#f4f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 5.885,
    y1: -4685.083,
    x2: 5.885,
    y2: -4686.056,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 803.608,
    y1: -30.892,
    x2: 803.608,
    y2: -30.899,
    xlinkHref: "#linear-gradient-58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22715",
    "data-name": "Groupe 22715",
    transform: "translate(-9 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22662",
    "data-name": "Groupe 22662",
    transform: "translate(6.51 -196.775)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22662-2",
    "data-name": "Groupe 22662",
    transform: "translate(16.723 247.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5676",
    "data-name": "Trac\\xE9 5676",
    d: "M43.372,298.861a7.708,7.708,0,1,1-7.708,7.708A7.708,7.708,0,0,1,43.372,298.861Z",
    transform: "translate(-35.514 -298.711)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5677",
    "data-name": "Trac\\xE9 5677",
    d: "M36.368,305.629l-1.021-.115.178-1.011,1,.238c.023-.095.046-.189.072-.282l-.987-.291.351-.964.944.407c.039-.089.084-.175.127-.262l-.924-.46.513-.889.858.565c.054-.081.115-.157.173-.235l-.832-.614.66-.786.75.708c.068-.07.136-.138.206-.206l-.711-.747.786-.66.617.829c.078-.058.154-.118.235-.173l-.568-.855.889-.513.463.923c.087-.043.173-.087.263-.127l-.411-.943.965-.351.3.986c.093-.027.188-.049.282-.072l-.242-1,1.011-.178.119,1.02c.095-.01.192-.012.287-.019l-.06-1.032h1.027l-.064,1.032c.1.006.2.008.291.019l.119-1.02,1.011.178-.242,1c.095.023.189.046.282.072l.295-.986.965.351-.411.943c.089.039.176.084.263.127l.463-.923.889.513-.568.855c.081.054.157.115.235.173l.617-.829.786.66-.711.747c.07.068.139.136.206.206l.75-.708.66.786-.831.614c.058.078.119.154.173.235l.858-.565.513.889-.925.46c.043.087.087.173.127.262l.945-.407.351.964-.987.291c.027.093.049.188.072.282l1-.238L51,305.514l-1.021.115c.01.1.013.194.019.291l1.032-.06v1.027L50,306.822c-.007.1-.009.195-.019.291l1.021.119-.178,1.011-1-.242c-.023.095-.046.189-.072.282l.986.3-.351.965-.943-.411c-.039.089-.083.176-.126.263l.923.463-.513.889-.855-.568c-.054.081-.115.157-.173.235l.829.616-.66.786-.747-.711c-.067.07-.136.139-.206.206l.708.75-.786.66-.614-.831c-.078.058-.154.119-.235.173l.564.857-.889.513-.46-.924c-.087.043-.173.087-.263.127l.408.944-.965.351-.291-.987c-.093.027-.187.049-.282.073l.238,1-1.011.178-.116-1.021c-.1.01-.2.013-.294.02l.064,1.031H42.662l.06-1.032c-.1-.007-.195-.009-.291-.019l-.115,1.021-1.011-.178.238-1c-.095-.023-.189-.046-.282-.073l-.292.987-.965-.351.408-.944c-.089-.039-.176-.084-.263-.127l-.46.924-.889-.513.564-.857c-.081-.054-.157-.115-.235-.173l-.614.831-.786-.66.708-.75c-.07-.068-.139-.136-.206-.206l-.747.711-.66-.786.829-.616c-.057-.078-.118-.154-.173-.235l-.855.568-.513-.889.923-.463c-.043-.087-.087-.173-.126-.263l-.943.411-.351-.965.986-.3c-.027-.093-.049-.188-.072-.282l-1,.242-.178-1.011,1.021-.119c-.01-.1-.013-.194-.019-.291l-1.032.064V305.86l1.032.06C36.355,305.823,36.358,305.726,36.368,305.629Z",
    transform: "translate(-35.317 -298.515)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5678",
    "data-name": "Trac\\xE9 5678",
    d: "M46.308,304.046a5.46,5.46,0,1,1-5.46,5.46A5.46,5.46,0,0,1,46.308,304.046Z",
    transform: "translate(-38.45 -301.648)",
    fill: "url(#radial-gradient-3)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5679",
    "data-name": "Trac\\xE9 5679",
    d: "M43.684,304.3l-.557,1.076a1.877,1.877,0,0,1-1.807,1.01l-20.691-1.539,2.524-10.609,16.1-1.652Z",
    transform: "translate(-10.274 -47.471)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22675",
    "data-name": "Groupe 22675",
    transform: "translate(13.625 249.072)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5680",
    "data-name": "Trac\\xE9 5680",
    d: "M33.46,302.2a8.021,8.021,0,1,1-4.806,10.274A8.021,8.021,0,0,1,33.46,302.2Z",
    transform: "translate(-28.171 -301.718)",
    fill: "url(#radial-gradient-5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5681",
    "data-name": "Trac\\xE9 5681",
    d: "M29.406,311.4l-1.02.245-.181-1.032,1.047-.121c-.01-.1-.022-.2-.029-.3l-1.048.064v-1.048l1.048.062c.007-.1.019-.2.03-.3l-1.047-.12.183-1.031,1.019.243c.024-.1.056-.191.084-.286l-1.011-.3.359-.985.966.419q.06-.136.127-.269l-.942-.47.525-.907.88.581c.055-.083.107-.167.165-.248l-.842-.623.675-.8.765.724c.069-.072.136-.144.208-.212l-.723-.762.8-.672.626.844c.08-.058.163-.113.245-.168l-.581-.879.908-.523.469.938c.088-.043.179-.078.269-.117l-.417-.969.985-.357.3,1.012c.1-.028.19-.06.286-.083l-.241-1.02,1.032-.181.117,1.047c.1-.011.2-.022.3-.029l-.06-1.049H36.73l-.067,1.048c.1.007.2.019.3.03l.124-1.046,1.031.183-.247,1.018c.1.024.19.056.286.084l.3-1.01.984.359-.422.965q.137.06.27.126l.473-.941.907.525-.584.878c.082.056.167.107.248.166l.626-.84.8.675-.727.763c.072.069.144.136.213.208l.764-.719.672.8-.846.623c.059.08.113.163.168.246l.881-.578.523.908-.94.466c.043.088.08.182.119.273l.969-.417.357.985-1.012.3c.028.1.06.19.083.286l1.021-.241.181,1.032-1.047.117c.011.1.022.2.029.3l1.049-.06v1.048l-1.048-.067c-.007.1-.019.2-.03.3l1.046.124L44,311.661l-1.018-.247c-.024.1-.056.19-.084.285l1.01.3-.359.984-.965-.422c-.04.091-.082.18-.126.27l.94.473-.525.907L42,313.632c-.055.082-.106.167-.165.248l.84.626-.674.8-.763-.727c-.069.072-.136.144-.208.213l.72.764-.8.672-.623-.846c-.08.058-.163.113-.246.168l.578.881-.908.523-.466-.94c-.09.044-.184.081-.276.121l.421.968-.985.357-.3-1.012c-.1.028-.19.059-.286.083l.245,1.02-1.032.181-.121-1.047c-.1.01-.2.022-.3.028l.064,1.049H35.662l.063-1.048c-.1-.007-.2-.019-.3-.03l-.119,1.047-1.032-.183.243-1.019c-.1-.024-.19-.056-.286-.084l-.3,1.011-.984-.359.418-.966q-.136-.061-.269-.126l-.47.942-.907-.525.581-.88c-.082-.055-.167-.107-.248-.165l-.623.842-.8-.675.724-.765c-.072-.068-.144-.136-.213-.208l-.762.723-.672-.8.844-.626c-.058-.08-.113-.163-.168-.246l-.879.581-.523-.908.938-.469c-.043-.088-.079-.182-.119-.273l-.968.421-.357-.985,1.011-.3C29.461,311.588,29.429,311.493,29.406,311.4Z",
    transform: "translate(-28.173 -301.72)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22674",
    "data-name": "Groupe 22674",
    transform: "translate(2.059 2.055)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5682",
    "data-name": "Trac\\xE9 5682",
    d: "M34.49,314.985a5.424,5.424,0,1,0,3.25-6.947A5.43,5.43,0,0,0,34.49,314.985Zm.68-.246a4.7,4.7,0,1,1,6.021,2.817A4.706,4.706,0,0,1,35.17,314.738Z",
    transform: "translate(-33.625 -307.169)",
    fill: "url(#radial-gradient-7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5683",
    "data-name": "Trac\\xE9 5683",
    d: "M34.235,314.844a5.488,5.488,0,0,0,2.343,2.844l-.017.017.112.043a.417.417,0,0,1,.051.024,5.536,5.536,0,0,0,2.425.7.408.408,0,0,1,.056.007l.114.023-.006-.024a5.5,5.5,0,0,0,3.776-1.4l.023.044.219-.269a.325.325,0,0,1,.023-.025,5.534,5.534,0,0,0,.653-.807l.014-.018h0a5.583,5.583,0,0,0,.39-.7l.011-.022.3-.539s-.031,0-.084-.009a5.488,5.488,0,0,0-.033-3.655c-.043-.118-.091-.234-.141-.347.077-.016.12-.022.12-.022L43.8,309.5h0l-.979-1.058s-.02.049-.06.131a5.535,5.535,0,0,0-3.837-1.109c.01-.087.018-.137.018-.137l-1.393.371v0l-1.308.6s.034.029.091.083a5.535,5.535,0,0,0-2.278,3.3l-.072-.035-.032.586a.246.246,0,0,1,0,.025,5.475,5.475,0,0,0,.08,1.867.3.3,0,0,1,.006.034l.042.358.044-.026C34.157,314.613,34.193,314.729,34.235,314.844Zm1.909-6.086a.426.426,0,0,1,.589.06,5.624,5.624,0,0,1,.754,1.166c.114.238.245.53.381.839a1,1,0,0,1-.947,1.4c-.336-.01-.654-.024-.917-.041a5.647,5.647,0,0,1-1.4-.277.429.429,0,0,1-.272-.533A5.352,5.352,0,0,1,36.143,308.758Zm6.2-.249a.426.426,0,0,1,.128.583,5.6,5.6,0,0,1-.861,1.055c-.192.182-.428.4-.68.621a1,1,0,0,1-1.625-.468c-.094-.323-.179-.63-.244-.885a5.6,5.6,0,0,1-.168-1.358.426.426,0,0,1,.42-.425A5.353,5.353,0,0,1,42.347,308.509Zm2.228,5.814a.427.427,0,0,1-.514.307,5.615,5.615,0,0,1-1.327-.508c-.233-.126-.51-.284-.8-.455a1,1,0,0,1-.057-1.69c.277-.189.543-.365.766-.506a5.624,5.624,0,0,1,1.261-.587.423.423,0,0,1,.529.255l0,.005A5.3,5.3,0,0,1,44.575,314.323Zm-4.9,3.966a.426.426,0,0,1-.445-.388,5.636,5.636,0,0,1,.068-1.485c.048-.26.113-.573.185-.9a1,1,0,0,1,1.59-.576c.265.206.515.4.718.572a5.645,5.645,0,0,1,.991,1.078.427.427,0,0,1-.087.584,5.315,5.315,0,0,1-3.019,1.118Zm-2.722-1.046a.427.427,0,0,1-.586.092,5.305,5.305,0,0,1-1.962-2.553v0a.425.425,0,0,1,.241-.534,5.623,5.623,0,0,1,1.41-.385c.261-.035.578-.07.912-.1a1,1,0,0,1,1.041,1.337c-.114.315-.224.613-.322.857A5.636,5.636,0,0,1,36.955,317.243Z",
    transform: "translate(-33.478 -306.953)",
    fill: "url(#radial-gradient-8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5684",
    "data-name": "Trac\\xE9 5684",
    d: "M33.211,314.275a5.966,5.966,0,1,0,3.456-7.388A5.966,5.966,0,0,0,33.211,314.275Zm2.921-6.522a.318.318,0,0,1,.419.091A14.439,14.439,0,0,1,38,310.684c.06.144.163.417.269.7a.564.564,0,0,1-.514.76c-.307.008-.6.014-.757.012a14.177,14.177,0,0,1-3.222-.3.318.318,0,0,1-.237-.363A5.437,5.437,0,0,1,36.132,307.753Zm2.768,4.615h0Zm3.521-4.05a.318.318,0,0,1,.047.431A14.5,14.5,0,0,1,40.226,311c-.119.1-.346.284-.586.473a.564.564,0,0,1-.881-.254c-.1-.29-.2-.567-.246-.716a14.5,14.5,0,0,1-.7-3.1.318.318,0,0,1,.267-.34A5.44,5.44,0,0,1,42.422,308.318Zm1.477,6.166a.317.317,0,0,1-.392.179,14.159,14.159,0,0,1-2.89-1.457c-.133-.081-.377-.242-.631-.411a.564.564,0,0,1-.031-.916c.244-.187.477-.365.605-.455a14.429,14.429,0,0,1,2.74-1.63.317.317,0,0,1,.4.145,5.4,5.4,0,0,1,.2,4.546Zm-3.166,3.041a5.39,5.39,0,0,1-2.3.3.318.318,0,0,1-.29-.316,13.862,13.862,0,0,1,.493-3.254c.036-.152.113-.433.2-.727a.564.564,0,0,1,.862-.313c.253.174.494.342.62.435a14.019,14.019,0,0,1,2.444,2.157.319.319,0,0,1-.017.427A5.388,5.388,0,0,1,40.732,317.525Zm-6.948-3.25a5.419,5.419,0,0,1-.2-.679.318.318,0,0,1,.213-.368,14.009,14.009,0,0,1,3.219-.527c.156-.012.447-.026.752-.039a.564.564,0,0,1,.564.723c-.087.295-.172.575-.222.724a13.876,13.876,0,0,1-1.312,3.015.318.318,0,0,1-.413.113A5.4,5.4,0,0,1,33.785,314.275Z",
    transform: "translate(-32.919 -306.459)",
    fill: "url(#radial-gradient-9)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22673",
    "data-name": "Groupe 22673",
    transform: "translate(4.34 4.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22664",
    "data-name": "Groupe 22664",
    transform: "translate(1.641 2.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22663",
    "data-name": "Groupe 22663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5685",
    "data-name": "Trac\\xE9 5685",
    d: "M47.589,322.456a.451.451,0,1,0-.27.577A.451.451,0,0,0,47.589,322.456Z",
    transform: "translate(-46.715 -322.158)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5686",
    "data-name": "Trac\\xE9 5686",
    d: "M47.242,322.5a.311.311,0,1,0,.4.187A.312.312,0,0,0,47.242,322.5Z",
    transform: "translate(-46.897 -322.341)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22666",
    "data-name": "Groupe 22666",
    transform: "translate(0.056 2.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22665",
    "data-name": "Groupe 22665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5687",
    "data-name": "Trac\\xE9 5687",
    d: "M43.785,321.911a.451.451,0,1,0-.633-.078A.451.451,0,0,0,43.785,321.911Z",
    transform: "translate(-43.057 -321.105)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5688",
    "data-name": "Trac\\xE9 5688",
    d: "M43.936,321.547a.311.311,0,1,0-.054.437A.312.312,0,0,0,43.936,321.547Z",
    transform: "translate(-43.24 -321.287)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22668",
    "data-name": "Groupe 22668",
    transform: "translate(0 0.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22667",
    "data-name": "Groupe 22667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5689",
    "data-name": "Trac\\xE9 5689",
    d: "M43.128,318.125a.451.451,0,1,0-.121-.626A.451.451,0,0,0,43.128,318.125Z",
    transform: "translate(-42.929 -317.301)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5690",
    "data-name": "Trac\\xE9 5690",
    d: "M43.82,318.108a.311.311,0,1,0-.432.084A.311.311,0,0,0,43.82,318.108Z",
    transform: "translate(-43.112 -317.483)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22670",
    "data-name": "Groupe 22670",
    transform: "translate(1.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22669",
    "data-name": "Groupe 22669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5691",
    "data-name": "Trac\\xE9 5691",
    d: "M46.525,316.329a.451.451,0,1,0,.558-.308A.451.451,0,0,0,46.525,316.329Z",
    transform: "translate(-46.507 -316.003)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5692",
    "data-name": "Trac\\xE9 5692",
    d: "M47.055,316.935a.311.311,0,1,0-.213-.385A.311.311,0,0,0,47.055,316.935Z",
    transform: "translate(-46.69 -316.185)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22672",
    "data-name": "Groupe 22672",
    transform: "translate(2.566 1.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22671",
    "data-name": "Groupe 22671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5693",
    "data-name": "Trac\\xE9 5693",
    d: "M49.283,319.006a.451.451,0,1,0,.466.435A.451.451,0,0,0,49.283,319.006Z",
    transform: "translate(-48.847 -319.005)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5694",
    "data-name": "Trac\\xE9 5694",
    d: "M49.17,319.649a.311.311,0,1,0,.3-.321A.312.312,0,0,0,49.17,319.649Z",
    transform: "translate(-49.03 -319.188)",
    fill: "url(#linear-gradient-10)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5695",
    "data-name": "Trac\\xE9 5695",
    d: "M45.252,319.514a.621.621,0,1,0,.372-.8A.621.621,0,0,0,45.252,319.514Z",
    transform: "translate(-39.884 -313.382)",
    fill: "url(#radial-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3273",
    "data-name": "Rectangle 3273",
    width: 21.372,
    height: 8.097,
    transform: "translate(32.943 255.575) rotate(180)",
    fill: "url(#linear-gradient-11)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22676",
    "data-name": "Groupe 22676",
    transform: "translate(92.47 245.319)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 7.708,
    cy: 7.708,
    r: 7.708,
    transform: "translate(0 5.967) rotate(-22.774)",
    fill: "url(#radial-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5696",
    "data-name": "Trac\\xE9 5696",
    d: "M216.227,305.327l-1.021-.115.179-1.011,1,.238c.023-.095.046-.189.073-.282l-.987-.291.351-.964.945.408c.039-.089.083-.176.127-.263l-.924-.46.513-.889.857.565c.055-.081.116-.156.173-.235l-.831-.614.66-.786.75.708c.067-.07.136-.139.206-.206l-.711-.747.786-.659.617.829c.078-.057.154-.118.235-.173l-.567-.855.889-.513.463.923c.087-.043.174-.087.263-.126l-.411-.943.965-.351.295.986c.093-.027.188-.049.282-.072l-.241-1,1.011-.178.119,1.02c.094-.01.191-.012.287-.018l-.06-1.032h1.027l-.064,1.032c.1.006.195.009.29.019l.119-1.02,1.011.178-.242,1c.095.023.189.046.282.072l.295-.986.965.351-.411.943c.089.039.176.083.263.126l.463-.923.889.513-.568.855c.081.054.157.115.235.173l.617-.829.786.659-.711.747c.07.068.139.136.206.206l.75-.708.66.786-.831.614c.058.078.119.154.173.235l.858-.565.513.889-.924.46c.043.087.087.173.127.263l.945-.408.351.964-.987.291c.027.093.049.188.073.282l1-.238.178,1.011-1.021.115c.01.1.013.194.019.291l1.032-.06v1.027l-1.032-.064c-.006.1-.008.195-.019.291l1.021.119-.178,1.011-1-.242c-.023.095-.046.189-.073.282l.986.3-.351.964-.943-.411c-.039.089-.083.176-.127.263l.923.463-.513.889-.855-.568c-.054.081-.115.157-.173.235l.829.617-.66.786-.747-.711c-.067.07-.136.139-.206.206l.708.75-.786.66-.613-.831c-.078.058-.154.119-.235.173l.564.858-.889.513-.46-.924c-.087.043-.173.087-.262.126l.408.945-.965.351-.291-.988c-.093.027-.188.05-.282.073l.238,1-1.011.178-.115-1.021c-.1.01-.2.013-.294.02l.064,1.032h-1.027l.06-1.032c-.1-.007-.195-.009-.291-.019l-.115,1.021-1.011-.178.238-1c-.095-.023-.189-.046-.282-.073l-.291.988-.965-.351.408-.945c-.089-.039-.175-.083-.262-.126l-.46.924-.889-.513.564-.858c-.081-.054-.157-.115-.235-.173l-.613.831-.786-.66.708-.75c-.07-.068-.138-.136-.206-.206l-.747.711-.66-.786.829-.617c-.058-.078-.118-.154-.173-.235l-.855.568-.513-.889.923-.463c-.043-.087-.087-.173-.127-.263l-.943.411-.351-.964.986-.3c-.027-.093-.049-.188-.073-.282l-1,.242-.179-1.011,1.021-.119c-.01-.1-.013-.194-.019-.291l-1.032.064v-1.027l1.032.06C216.214,305.521,216.217,305.424,216.227,305.327Z",
    transform: "translate(-212.943 -295.98)",
    fill: "url(#radial-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5697",
    "data-name": "Trac\\xE9 5697",
    d: "M226.167,303.744a5.46,5.46,0,1,1-5.46,5.46A5.46,5.46,0,0,1,226.167,303.744Z",
    transform: "translate(-216.076 -299.113)",
    fill: "url(#radial-gradient-13)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5698",
    "data-name": "Trac\\xE9 5698",
    d: "M239.088,303.159l-.557,1.076a1.878,1.878,0,0,1-1.807,1.01l-20.691-1.54,2.524-10.609,16.1-1.652Z",
    transform: "translate(-120.959 -46.827)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22689",
    "data-name": "Groupe 22689",
    transform: "translate(97.243 249.072)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5699",
    "data-name": "Trac\\xE9 5699",
    d: "M226.325,302.2a8.021,8.021,0,1,1-4.806,10.274A8.021,8.021,0,0,1,226.325,302.2Z",
    transform: "translate(-221.036 -301.718)",
    fill: "url(#radial-gradient-15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5700",
    "data-name": "Trac\\xE9 5700",
    d: "M222.27,311.4l-1.02.245-.181-1.032,1.047-.121c-.01-.1-.022-.2-.028-.3l-1.049.064v-1.048l1.048.062c.007-.1.019-.2.03-.3l-1.047-.12.183-1.031,1.019.243c.024-.1.056-.191.084-.286l-1.011-.3.36-.985.966.419c.04-.091.082-.18.127-.269l-.942-.47.525-.907.88.581c.055-.083.107-.167.165-.248l-.842-.623.675-.8.765.724c.068-.072.136-.144.208-.212l-.723-.762.8-.672.626.844c.08-.058.163-.113.246-.168l-.581-.879.908-.523.469.938c.088-.043.179-.078.269-.118l-.417-.969.985-.357.3,1.012c.1-.028.19-.06.286-.083l-.241-1.02,1.032-.181.117,1.047c.1-.011.2-.022.3-.029l-.06-1.049h1.048l-.067,1.048c.1.007.2.019.3.03l.124-1.046,1.032.183-.247,1.018c.1.024.19.056.286.084l.3-1.01.984.359-.422.965q.137.06.27.126l.473-.941.907.525-.584.878c.083.056.167.107.248.166l.626-.84.8.675-.727.763c.072.069.144.136.213.208l.765-.719.672.8-.846.623c.059.08.113.163.168.246l.881-.578.522.908-.94.466c.043.088.08.182.12.273l.969-.417.357.985-1.012.3c.028.1.06.19.083.286l1.021-.241.181,1.032-1.048.117c.011.1.022.2.029.3l1.049-.06v1.048l-1.048-.067c-.007.1-.019.2-.03.3l1.047.124-.183,1.031-1.018-.247c-.024.1-.056.19-.084.285l1.01.3-.359.984-.965-.422c-.04.091-.082.18-.126.27l.94.473-.525.907-.878-.584c-.055.082-.107.167-.166.248l.84.626-.674.8-.763-.727c-.069.072-.136.144-.208.213l.72.764-.8.672-.623-.846c-.08.058-.163.113-.246.168l.578.881-.908.523-.466-.94c-.09.044-.184.081-.276.121l.42.968-.985.357-.3-1.012c-.1.028-.19.059-.286.083l.245,1.02-1.032.181-.121-1.047c-.1.011-.2.023-.3.029l.064,1.049h-1.048l.063-1.048c-.1-.007-.2-.019-.3-.03l-.119,1.047-1.032-.183.243-1.019c-.1-.024-.19-.056-.286-.084l-.3,1.011-.984-.359.418-.966c-.091-.04-.18-.082-.269-.126l-.47.942-.907-.525.581-.88c-.082-.055-.167-.107-.247-.165l-.624.842-.8-.675.724-.765c-.072-.068-.144-.136-.213-.208l-.762.723-.672-.8.844-.626c-.058-.08-.113-.163-.168-.246l-.879.581-.522-.908.938-.469c-.043-.088-.08-.182-.119-.273l-.968.421-.357-.985,1.012-.3C222.325,311.588,222.293,311.493,222.27,311.4Z",
    transform: "translate(-221.038 -301.72)",
    fill: "url(#radial-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22688",
    "data-name": "Groupe 22688",
    transform: "translate(2.058 2.055)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5701",
    "data-name": "Trac\\xE9 5701",
    d: "M227.355,314.985a5.423,5.423,0,1,0,3.25-6.947A5.43,5.43,0,0,0,227.355,314.985Zm.679-.246a4.7,4.7,0,1,1,6.022,2.817A4.706,4.706,0,0,1,228.034,314.738Z",
    transform: "translate(-226.489 -307.169)",
    fill: "url(#radial-gradient-17)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5702",
    "data-name": "Trac\\xE9 5702",
    d: "M227.1,314.844a5.488,5.488,0,0,0,2.343,2.844l-.017.017.113.043a.442.442,0,0,1,.05.024,5.536,5.536,0,0,0,2.425.7.346.346,0,0,1,.056.007l.114.023-.005-.024a5.5,5.5,0,0,0,3.776-1.4l.023.044.219-.269.023-.026a5.511,5.511,0,0,0,.653-.806l.014-.018h0a5.52,5.52,0,0,0,.39-.7l.012-.022.3-.539s-.031,0-.084-.009a5.488,5.488,0,0,0-.033-3.655c-.043-.118-.091-.234-.141-.347.077-.016.12-.022.12-.022l-.783-1.211h0l-.979-1.058s-.02.049-.06.131a5.535,5.535,0,0,0-3.837-1.109c.01-.087.018-.137.018-.137l-1.393.371v0l-1.308.6s.034.029.091.083a5.535,5.535,0,0,0-2.278,3.3l-.072-.035-.032.586c0,.009,0,.017,0,.026a5.475,5.475,0,0,0,.079,1.867.291.291,0,0,1,.006.034l.042.358.044-.026C227.021,314.613,227.057,314.729,227.1,314.844Zm1.909-6.086a.426.426,0,0,1,.589.06,5.631,5.631,0,0,1,.754,1.166c.114.238.246.53.381.839a1,1,0,0,1-.947,1.4c-.336-.011-.654-.024-.917-.041a5.625,5.625,0,0,1-1.4-.277.429.429,0,0,1-.272-.532A5.352,5.352,0,0,1,229.008,308.758Zm6.2-.249a.426.426,0,0,1,.128.583,5.6,5.6,0,0,1-.861,1.055c-.192.182-.428.4-.68.621a1,1,0,0,1-1.625-.468c-.094-.323-.179-.63-.245-.885a5.6,5.6,0,0,1-.168-1.358.426.426,0,0,1,.42-.425A5.353,5.353,0,0,1,235.211,308.509Zm2.228,5.814a.427.427,0,0,1-.514.307,5.616,5.616,0,0,1-1.327-.508c-.232-.126-.51-.284-.8-.455a1,1,0,0,1-.057-1.69c.278-.189.543-.365.766-.506a5.624,5.624,0,0,1,1.261-.587.424.424,0,0,1,.529.255l0,.006A5.3,5.3,0,0,1,237.439,314.323Zm-4.9,3.966a.426.426,0,0,1-.446-.388,5.635,5.635,0,0,1,.068-1.485c.048-.26.113-.574.185-.9a1,1,0,0,1,1.59-.576c.265.206.515.4.718.572a5.644,5.644,0,0,1,.991,1.078.427.427,0,0,1-.087.584,5.315,5.315,0,0,1-3.018,1.118Zm-2.722-1.046a.427.427,0,0,1-.586.092,5.305,5.305,0,0,1-1.962-2.553v0a.425.425,0,0,1,.241-.534,5.623,5.623,0,0,1,1.41-.385c.261-.035.578-.07.912-.1a1,1,0,0,1,1.041,1.337c-.113.315-.224.613-.322.857A5.645,5.645,0,0,1,229.82,317.243Z",
    transform: "translate(-226.342 -306.953)",
    fill: "url(#radial-gradient-18)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5703",
    "data-name": "Trac\\xE9 5703",
    d: "M226.075,314.275a5.966,5.966,0,1,0,3.456-7.388A5.966,5.966,0,0,0,226.075,314.275ZM229,307.753a.318.318,0,0,1,.419.091,14.435,14.435,0,0,1,1.453,2.839c.059.144.163.417.269.7a.564.564,0,0,1-.514.76c-.307.008-.6.014-.757.012a14.177,14.177,0,0,1-3.222-.3.319.319,0,0,1-.237-.363A5.437,5.437,0,0,1,229,307.753Zm2.768,4.615h0Zm3.521-4.05a.318.318,0,0,1,.047.431A14.5,14.5,0,0,1,233.09,311c-.119.1-.346.284-.586.473a.564.564,0,0,1-.881-.254c-.1-.29-.2-.567-.246-.716a14.5,14.5,0,0,1-.7-3.1.318.318,0,0,1,.267-.34A5.439,5.439,0,0,1,235.286,308.318Zm1.477,6.166a.317.317,0,0,1-.392.179,14.16,14.16,0,0,1-2.89-1.457c-.133-.081-.377-.242-.631-.411a.564.564,0,0,1-.031-.916c.244-.187.478-.365.605-.455a14.43,14.43,0,0,1,2.74-1.63.317.317,0,0,1,.4.145,5.4,5.4,0,0,1,.2,4.546Zm-3.166,3.041a5.389,5.389,0,0,1-2.3.3.319.319,0,0,1-.29-.316,13.86,13.86,0,0,1,.493-3.254c.036-.152.113-.433.2-.727a.564.564,0,0,1,.862-.313c.253.174.494.342.62.435a14.015,14.015,0,0,1,2.444,2.158.319.319,0,0,1-.017.427A5.388,5.388,0,0,1,233.6,317.525Zm-6.947-3.25a5.348,5.348,0,0,1-.2-.679.318.318,0,0,1,.213-.368,14,14,0,0,1,3.219-.527c.156-.013.447-.026.752-.039a.564.564,0,0,1,.563.723c-.087.295-.172.575-.222.724a13.875,13.875,0,0,1-1.312,3.015.318.318,0,0,1-.413.113A5.4,5.4,0,0,1,226.649,314.275Z",
    transform: "translate(-225.783 -306.459)",
    fill: "url(#radial-gradient-19)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22687",
    "data-name": "Groupe 22687",
    transform: "translate(4.34 4.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22678",
    "data-name": "Groupe 22678",
    transform: "translate(1.641 2.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22677",
    "data-name": "Groupe 22677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5704",
    "data-name": "Trac\\xE9 5704",
    d: "M240.454,322.456a.451.451,0,1,0-.27.577A.45.45,0,0,0,240.454,322.456Z",
    transform: "translate(-239.579 -322.158)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5705",
    "data-name": "Trac\\xE9 5705",
    d: "M240.106,322.5a.311.311,0,1,0,.4.186A.312.312,0,0,0,240.106,322.5Z",
    transform: "translate(-239.761 -322.341)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22680",
    "data-name": "Groupe 22680",
    transform: "translate(0.056 2.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22679",
    "data-name": "Groupe 22679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5706",
    "data-name": "Trac\\xE9 5706",
    d: "M236.649,321.911a.451.451,0,1,0-.633-.078A.451.451,0,0,0,236.649,321.911Z",
    transform: "translate(-235.921 -321.105)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5707",
    "data-name": "Trac\\xE9 5707",
    d: "M236.8,321.547a.311.311,0,1,0-.054.437A.312.312,0,0,0,236.8,321.547Z",
    transform: "translate(-236.104 -321.287)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22682",
    "data-name": "Groupe 22682",
    transform: "translate(0 0.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22681",
    "data-name": "Groupe 22681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5708",
    "data-name": "Trac\\xE9 5708",
    d: "M235.992,318.124a.451.451,0,1,0-.121-.626A.45.45,0,0,0,235.992,318.124Z",
    transform: "translate(-235.793 -317.3)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5709",
    "data-name": "Trac\\xE9 5709",
    d: "M236.684,318.108a.311.311,0,1,0-.432.084A.311.311,0,0,0,236.684,318.108Z",
    transform: "translate(-235.976 -317.483)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22684",
    "data-name": "Groupe 22684",
    transform: "translate(1.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22683",
    "data-name": "Groupe 22683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5710",
    "data-name": "Trac\\xE9 5710",
    d: "M239.39,316.329a.451.451,0,1,0,.558-.308A.451.451,0,0,0,239.39,316.329Z",
    transform: "translate(-239.372 -316.003)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5711",
    "data-name": "Trac\\xE9 5711",
    d: "M239.919,316.935a.311.311,0,1,0-.213-.385A.311.311,0,0,0,239.919,316.935Z",
    transform: "translate(-239.554 -316.185)",
    fill: "url(#linear-gradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22686",
    "data-name": "Groupe 22686",
    transform: "translate(2.566 1.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22685",
    "data-name": "Groupe 22685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5712",
    "data-name": "Trac\\xE9 5712",
    d: "M242.147,319.006a.451.451,0,1,0,.466.435A.451.451,0,0,0,242.147,319.006Z",
    transform: "translate(-241.711 -319.005)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5713",
    "data-name": "Trac\\xE9 5713",
    d: "M242.034,319.649a.311.311,0,1,0,.3-.321A.311.311,0,0,0,242.034,319.649Z",
    transform: "translate(-241.894 -319.188)",
    fill: "url(#linear-gradient-21)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5714",
    "data-name": "Trac\\xE9 5714",
    d: "M238.116,319.514a.621.621,0,1,0,.372-.8A.621.621,0,0,0,238.116,319.514Z",
    transform: "translate(-232.748 -313.382)",
    fill: "url(#radial-gradient-20)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3274",
    "data-name": "Rectangle 3274",
    width: 21.372,
    height: 7.771,
    transform: "translate(115.695 256.285) rotate(180)",
    fill: "url(#linear-gradient-22)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5715",
    "data-name": "Trac\\xE9 5715",
    d: "M137.787,324.478h15.788l1.217-.779h7.018l1.364.779h5.049a1.25,1.25,0,0,0,1.25-1.25v-.58H136.537v.58A1.25,1.25,0,0,0,137.787,324.478Z",
    transform: "translate(-75.929 -64.502)",
    fill: "url(#radial-gradient-21)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5716",
    "data-name": "Trac\\xE9 5716",
    d: "M266.472,313.673a22.862,22.862,0,0,0-.343,3.349c0,1.454.343,3.81.343,4.061,0,.13-.773-.664-.875-1.055a15.517,15.517,0,0,1-.636-3.248c-.251-3.274.938-4.32.938-4.32Z",
    transform: "translate(-148.654 -58.731)",
    fill: "url(#linear-gradient-23)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5717",
    "data-name": "Trac\\xE9 5717",
    d: "M69.879,314.612a22.865,22.865,0,0,0-.343,3.349c0,1.454.343,3.81.343,4.061,0,.131-.773-.664-.875-1.055a15.522,15.522,0,0,1-.635-3.248c-.251-3.274.938-4.32.938-4.32Z",
    transform: "translate(-37.296 -59.263)",
    fill: "url(#linear-gradient-24)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5718",
    "data-name": "Trac\\xE9 5718",
    d: "M4.123,241.844c4.367-3.6,14.684-9.092,14.684-9.092l.758-.05s12.7-12.555,16.885-16.793c4.517-4.578,10.145-7.124,23.495-7.124h.014c.263-.007.527-.01,2.37-.01h67.662c3.127,0,4.343,1.838,4.575,4.249.545,5.634,1.428,11.984,1.466,16.064.03,3.238-.156,20.765-.208,25.483a1.521,1.521,0,0,1-1.147,1.458l-5.835,2.344-12.39.047-2.244-6.7a3.443,3.443,0,0,0-3.264-2.349H100.272a3.443,3.443,0,0,0-3.266,2.355l-2.247,6.746-4.52.014L77.1,258.54l-46,.156V252.24c-8.23-9.365-18.663-3.658-18.663,4.486v2.026l-.578-.349-7.951-1.782S1.059,244.367,4.123,241.844Z",
    transform: "translate(-0.121 0)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5719",
    "data-name": "Trac\\xE9 5719",
    d: "M136.061,298.731l-6.755,3.043-12.39.043-2.26-6.735a3.424,3.424,0,0,0-3.246-2.334H100.72a3.424,3.424,0,0,0-3.249,2.344l-2.251,6.77-63.658.148v-6.389c-8.23-9.365-18.663-3.658-18.663,4.486v1.9h-.2l-.375-.227L4.372,300S1.617,288.156,6.016,285.36H137.881Z",
    transform: "translate(-0.583 -43.381)",
    fill: "url(#linear-gradient-26)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5720",
    "data-name": "Trac\\xE9 5720",
    d: "M8.407,296.962a17.154,17.154,0,0,1,34.308,0,17.341,17.341,0,0,1-.11,1.944l-8.273.026v-6.456c-8.23-9.365-18.663-3.658-18.663,4.486v2.026l-.578-.349-6.682-1.5C8.409,297.081,8.407,297.022,8.407,296.962Z",
    transform: "translate(-3.351 -40.236)",
    fill: "url(#radial-gradient-22)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5721",
    "data-name": "Trac\\xE9 5721",
    d: "M20.013,303.957a11.623,11.623,0,1,1,23.244.148v1.406l-2.153.007V304.1a9.47,9.47,0,1,0-18.938-.141Z",
    transform: "translate(-9.926 -47.331)",
    fill: "#b8b8be",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5722",
    "data-name": "Trac\\xE9 5722",
    d: "M6.665,292.364H2.786c-.225-3.095-.052-6.238,1.338-7.381l.061-.049H6.665Z",
    transform: "translate(-0.121 -43.139)",
    fill: "#f8f8f8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3275",
    "data-name": "Rectangle 3275",
    width: 21.457,
    height: 1.317,
    transform: "translate(52.437 259.061) rotate(180)",
    fill: "url(#linear-gradient-27)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5723",
    "data-name": "Trac\\xE9 5723",
    d: "M2.572,301.609c.131-.95,10.872-.579,11.177-.4a11.025,11.025,0,0,0-2.653,4.6,29.4,29.4,0,0,0-.831,4.671s-5.971-.24-7.162-1.357C2.35,308.419,2.465,302.379,2.572,301.609Z",
    transform: "translate(-0.002 -52.231)",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22690",
    "data-name": "Groupe 22690",
    transform: "translate(2.537 248.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5724",
    "data-name": "Trac\\xE9 5724",
    d: "M9.962,301.413c.1.39-.717,6.255-1.7,7.235-.757.754-3.847.235-4.412.235S2.183,304,2.762,301.633C2.922,300.978,9.8,300.809,9.962,301.413Z",
    transform: "translate(-2.598 -301.04)",
    fill: "#7f7f83",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5725",
    "data-name": "Trac\\xE9 5725",
    d: "M9.857,301.485c.092.372-.754,5.779-1.661,6.692-.7.707-3.586.3-4.113.3s-1.6-4.62-1.046-6.788C3.193,301.074,9.714,300.9,9.857,301.485Z",
    transform: "translate(-2.76 -301.089)",
    fill: "#868688",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5726",
    "data-name": "Trac\\xE9 5726",
    d: "M9.751,301.558c.082.355-.79,5.3-1.623,6.149-.647.659-3.324.369-3.814.369s-1.526-4.354-1-6.326C3.464,301.17,9.622,301,9.751,301.558Z",
    transform: "translate(-2.92 -301.139)",
    fill: "#8c8c8e",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5727",
    "data-name": "Trac\\xE9 5727",
    d: "M9.647,301.63c.072.337-.827,4.829-1.585,5.605-.593.612-3.063.437-3.516.437s-1.453-4.089-.96-5.865C3.737,301.265,9.531,301.09,9.647,301.63Z",
    transform: "translate(-3.083 -301.189)",
    fill: "#939393",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5728",
    "data-name": "Trac\\xE9 5728",
    d: "M9.543,301.7c.063.32-.865,4.352-1.546,5.062-.54.563-2.8.5-3.218.5s-1.379-3.824-.918-5.4C4.009,301.36,9.441,301.183,9.543,301.7Z",
    transform: "translate(-3.245 -301.238)",
    fill: "#999998",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5729",
    "data-name": "Trac\\xE9 5729",
    d: "M9.44,301.774a14.606,14.606,0,0,1-1.507,4.519c-.486.516-2.54.571-2.919.571s-1.3-3.557-.875-4.941C4.283,301.456,9.352,301.277,9.44,301.774Z",
    transform: "translate(-3.408 -301.287)",
    fill: "#a0a09e",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5730",
    "data-name": "Trac\\xE9 5730",
    d: "M9.338,301.847a13.655,13.655,0,0,1-1.469,3.975c-.432.468-2.278.637-2.62.637s-1.226-3.291-.832-4.479C4.558,301.551,9.263,301.37,9.338,301.847Z",
    transform: "translate(-3.572 -301.337)",
    fill: "#a6a6a3",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5731",
    "data-name": "Trac\\xE9 5731",
    d: "M9.236,301.919a12.785,12.785,0,0,1-1.431,3.432,5.2,5.2,0,0,1-2.322.7c-.3,0-1.145-3.025-.79-4.017C4.834,301.645,9.176,301.463,9.236,301.919Z",
    transform: "translate(-3.737 -301.386)",
    fill: "#adada9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5732",
    "data-name": "Trac\\xE9 5732",
    d: "M9.136,301.99a12.073,12.073,0,0,1-1.392,2.889,4.8,4.8,0,0,1-2.023.772c-.268,0-1.06-2.757-.747-3.555C5.113,301.741,9.091,301.556,9.136,301.99Z",
    transform: "translate(-3.903 -301.435)",
    fill: "#b3b3ae",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5733",
    "data-name": "Trac\\xE9 5733",
    d: "M9.038,302.063a11.621,11.621,0,0,1-1.354,2.346,4.466,4.466,0,0,1-1.724.839,5.455,5.455,0,0,1-.7-3.093C5.395,301.836,9.007,301.649,9.038,302.063Z",
    transform: "translate(-4.071 -301.484)",
    fill: "#babab3",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5734",
    "data-name": "Trac\\xE9 5734",
    d: "M8.94,302.135a11.7,11.7,0,0,1-1.315,1.8,4.245,4.245,0,0,1-1.426.906,4.984,4.984,0,0,1-.662-2.631C5.681,301.934,8.925,301.743,8.94,302.135Z",
    transform: "translate(-4.239 -301.534)",
    fill: "#c0c0b9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5735",
    "data-name": "Trac\\xE9 5735",
    d: "M8.844,302.211c0,.2-1.12,1.027-1.277,1.259a4.225,4.225,0,0,1-1.128.973,4.7,4.7,0,0,1-.619-2.17C5.976,302.041,8.844,301.84,8.844,302.211Z",
    transform: "translate(-4.409 -301.587)",
    fill: "#c7c7be",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5736",
    "data-name": "Trac\\xE9 5736",
    d: "M4.445,314.722a48.249,48.249,0,0,0,5.971.154c-.093,1.71-.039,3.06-.039,3.06s-5.971-.24-7.162-1.357a5.123,5.123,0,0,1-.523-2.434A9.476,9.476,0,0,0,4.445,314.722Z",
    transform: "translate(-0.114 -59.685)",
    fill: "url(#linear-gradient-29)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5737",
    "data-name": "Trac\\xE9 5737",
    d: "M2.672,301.609c.131-.95,10.872-.579,11.177-.4l-.243.9a60.222,60.222,0,0,0-9.059-.485C3.754,301.695,2.641,301.834,2.672,301.609Z",
    transform: "translate(-0.103 -52.231)",
    fill: "url(#linear-gradient-30)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 15.296,
    height: 9.365,
    transform: "translate(6.544 232.389)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAABaCAYAAAC8AmRpAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAk6ADAAQAAAABAAAAWgAAAADsyINMAAAOgElEQVR4Ae2dC1xUVR7Hf8MwvJXXMAjDS5B8ZKampIjgE81S7GGlbbWfHrttLzNTU9PPJ1vb2o/tVmv1yd39mKbi2xTF7NOWj2zbNAMTFR8YICgwCJKQiDr7/x+8iMRrmDsjzJz5NN3hzr1n7vndr+eec/6PozGbzZAvqUBbFFiwYIF5/vz5GuVcF+WD3EoFLFGAQeLjU1esMXt7e4vPEiZLFJTHCgUUkLpFxSIrKwtXrlzBjrRUs4RJAmKRAgpI0RExAqSFb72BuTNfhM5VB43sM1mkpVMfrIAUGRaFPXv2YGXqp5gx7VkMS4zHtz8cljA5NR0WVF4BKTa6O9K2bsGXX+3Ak49PRkL8IBw8+jNmz56rkS2TBYI666FvvrnQfPnyFfSM7YVNmzdh77e78PQTj6B/39uRdSwXM2bOFiM6CZOzEtKKenNr5OKigYuLC3rdchs+Wb4Ux45nYcpD96JP7944kXsGL0+fWTc1IGFqhajOeAiDZNAb4NvZH54ennh70VvQaa9i4oSxCAuPwNETp1F/jok1cnVGoWSdm1eAQerk7SMO0ml1dSDxo83LuxM92vJ+AxIfLFum5nV1qm+V1igsJBy/VF7AoZ9+wrKVyxAdaRR9pJqrLjh9prRRkCRMToVK05X926J3zBeqKsUB/GjDFY2AKDv7MJ556jEkDInD/oM54vuGj7b6pcqWqb4aTvaZWyKlygxRF0MoNn62Aes2rMWSxX9FcYkJt/bqgR8P5WD2nLl1HW3lnIZbCVNDRZzgb4bI3d0d7m789kBIcCjSt29D+o50hIUaMG7MCNw5sD8Kis41+1hrKJWEqaEiDvy3gMjNDW4CIncEBRqQkZGBzWmfQacDxiaPwJDBA2Aqu4C8AlOTfaOmJJIwNaWMA+2vg0hXC1KAv150rrd/sR2lpUUYkZSAEcOGwNfXT4zUamiCsrm+UVPSSJiaUsYB9jNEbtTkuBFEOnoH+AXi8JEjWLbiE2hdzDdAZCqrsOiR1pg8EqbGVOng+xSIdASSzrUWoqrKKjFC++HAfkyelEItUQJCugQjr7DEaogUuSRMihIOshWPtGud60A/PS5erManK5djz97deHTKAxg1fCjCjKH4+XSRahAp0kmYFCU6+JYhUqoQFdYVPjRTvX7TOjHUj7ujr+gTJSYMRm5BMUFkwrx5191tlfOs3UqYrFXwJp9fH6LIsEj4U79oS9pmrF2/Bj26x2DMqGEYOTwBuacJorOlmDv3tRbni9paJQlTW5W7yefVh0iZcNz+eTpWr1uN2JhIJI9KQtLQwSgynUchQfQq+RvZ+pIlTLZWWOXyG4NoxxefIy09jeaNfAmiYRgyaAAqKqtRSJOOM2fV+hqpfBmNFidhalSW9rezMYj27ftejNAC/TsheWQShsTHke+RK46dKsArM161eUvUUCUJU0NF2tnfDSEKoBFaZmYGtmzbgoqKczfMFWUdz0NNTdsmHNWotoRJDRVtUEZDiNhJjV1Ctm3firJy0w0QqTHhqEYVJExqqKhiGQpEvp19hSGWISouKqaOdSoOHz6E+1LGiWG+wWBAwVmT6nNF1lRFwmSNeiqfyyB5e3mD3wzR+bJy0SfKyDiAhydNFBAFBxvEPFFzTmoqX1ari5MwtVoq2x3YEkQ9e8RiQP/bbTJrrWatJExqqmlhWQyRPiAIpnMliO16i7CjvfPeInz3v/+KOaJRI4Yi/s6B7R4ipdoSJkUJO24ZokByA9GIwbsG4aERok+0cdMGepylIIYmHRMpuPFEbmG76hO1JJGEqSWFVPyeIQrwD0TtBJAGxi5GbCCA1m9ajzv69cbY0cMxkOxolno4qniJVhUlYbJKvtadzBD5+wXUQkTNkbFLGPbv34eVq1fAGBok7GdxA/rhTHE52c9sY4Rt3ZVad5SEyTr9mj1bQETeixRRRv9pwP2j7KNHhXNaTc1FjB6RhAfvH4/LV8zIPJKD115T35Lf7AWq/KWESWVBleIYJE8PD3i4e8DfNxAnc3Lw9c6vcPzEEZE1hP2K9EFBKCk9Ty3SObLmz7O7+UO5VrW2Eia1lLxWDkOkFNk1IhqXqmuwglLPfPfdt7h3wl0YSSO0YEMwSssraNKxFHPm2M4lRLkOe20lTCopXR+iqPCu8PLwxkdLPsTO3V9j0n33kIdjIqK7Roo+kb1cQlSqWquLkTC1WqrGD1QgCqRRmlarRSh1rlevTcW29K24/baeSB6dJIb57OFYWFSKWa/O6fCPs8aVkLkGmtKlxf0MkY+3t5hoZMd9joZl57Q15JwWEx0hXEKGJcVTn6jC7n5FLV68jQ6QLZOFwjJE3l5edJZGTDpGGLvixx8PCBtarXNaEuIHDcSFqksCohkz7e9XZGGVVDtcwtRKKRkiL0/POohCu4QjLzdXDPMrKyuES0jK+DHCOe34qUJMnzHLYR9nTUkmYWpKmXr7GSSdzlVklDWGRCA/Lx+btmzE8eNHMX5csrDm6/V6McR/4unnnA4iRSoJk6JEI1uGSNnNOYsuXbyErdvT8J+vvsRocthPHpGImG7ROGNhggelTEfbSpgauaP1ITKGhMHXx088zraS0/49d43CaPK37k2pZmwRyNjI5XSYXRKmereKIWLHtNrYfB24NVq1ZlVdIKMyzD9Tcg7ZJwvalNyh3s853EcJE93SWoi8RHIHBomH+bt27xSG2B6x0WKuiK3553/5FUUlZXhh6nSn7Rc19y/AqWFiiLw8vURL5EZ5ixgiJXzIx8sd7Jw2/u5kVDBEpnI8/+LLEqJmaHJKmBgirdaFTB5e8CSYlMiPzylfkelavqKxycPFd/kUl//cC9MkRM1ApHzldDAxSJwoXUMuIdGRsTBR3sZVa1aisDDvN+FDzjzMVwCxZOs0MDFEijC8/kdjkR9dKF9Rvor5ipTfc5atw8PEEHFih2JTMRgiTpK+buNakSVkOK1GNGb0MHKV7SeH+SoQ77AwMUTs2chO+/xIa2qY39Gc9lW45zYrwuFgYojYHYQBYmNsaLARazesuWGuSDjtn7UsLbHN7oADFexQMDFIbIz1pFGan28AjrK/9adLCayrYrkGhuhi9WVkHj4lJxxtALFDwMQQKdpER8bg18pfsXzVcpw6dUIYYdnf2s/fHxlZEiJFJ1tsOzRMDJFvJ19oXbVw1bpSCFE4UteuEp6OvCYaQxQYqKck6ZyWuOOGENnixtuizA4JE0PUyaeT6BfRjJGIiN1GyzXs+HIHjCF6EYfGqYlr8ziaHCLywxY3X+0yOxxMDJL7tSUb2PyRc/KksOhXV1fhd5Pvx+C4O3DufBVFxZaKdWPVFkyW17QCHQam+v2iCGMkYNZg1eqVyDx4AIkJgzCBbGgBAYE4lP2zQzvtN30rb/437R4mBaIACq92dXWloT5Ff1DiK05NnHLPGIqKTURERDjOkjW/PeYsuvm32H5X0G5hYog8RKZ9D/ByVoH+QcIt5DNagYgTgk6isGrOFMKx+RwRO/0V5/O5th8mrfuldgkTg+R6bYQWboxCwekC0S/ihKD3T7wbCZRVtrrGLCCqv3p166osj7KVAu1qwWflkcaVNei7wNPdC+8vfo8mH7MwcfxdYs6Il7HKyT+Ll6bNkG4htqKijeW2i5aJIeKZazedOy2s54YQgxFr1q8WJpDhFMjIOa579ewuYvOlW0gb77QdTrupMDFEnClEWZmRh/rf7P1GdLB5xWrF51oaY+1Aggo/cdNgYpDqZ5blHNdf0KRjcckZsUbsRMoY8kvlRXIdKcezz0tPRxXutc2LsDtMDBG7hrC3Y1PpiblfxOt+PPPcVNkvsjkC6v2A3WBiiHiuiF1DNBoXyhZCriE0V8RLnw+K648nH59MKflCpJOaevfW7iXZBabavhG7hnhSFrUAZGdn4xNyDYmKCJX9Irvfctv9oE1hYojYIKtz1YnZa72/Af/48H1KyZdNw/wEPEKW/e8zT8BMDiRtWa3adrLIktuigM3mmRgkNsjyK4S8HTl3ET/W+vbphTfmz4ReH4RCyi7LLwmSkKHD/0/1lokhUlSJMEbgYlU13l38d1oPxE047/PqjGdLzotFZBwpn6NSZ2feqgYTQ+RGGdQ8qF/EGWYVg+w68r/mtDOcHJRHaUdO5mPWLMdNxSdhslIBBokjZLUuWkSGR4t10ZatXEZBjrUTjx1p/Q8rpXDq061qmeo/0kIMIbT8eWe8/8F7ddGxDz+YgrLzlThbXIaXXpa2NEcnrc0wMUgc3MgvNoNw53oDrQGSNHQQHp38AOW6pnXRyD1E2tIcHaHr9bMYJobIr7MfyivK0Y2Wtco6dAi8rFUchRFJW9p1YZ3xk0UwMUjcueZ3GC1rtSVtM6UqTq1bpZE72BkyJs0ZORJ1bhVMDJG7mzuqL1WD/a/NV4El//5Y9I2e+v0UDBkcJ80gTovQ9Yq3CBOD5EqZ97UUl8YBjrt278K/lv4T/frcij8+9ahw4s88cgrz5nXsFYmuSyI/tVWBZmFikBQ3ETaFcN+I8xjF3zkA48aOhEbrhpy8IjmD3Vb1Hey8JmFikLiuvHbsIepk87yR1sUsEmLxkD/rWD6k/7WD0WBldRqFqQ4kymeUnr4N6ymfkcGgx0MPpKBHz14ypMhK0R319BtgUh5rlVWV6N39NrF27Dd7d5KrSDiBNAE6Dx/84U8vSoc1R6XBynrVeQ0wSDzk51efXn3xwUeLkXU4E/379hEgnS6uwOxpEiQr9Xbo0wVMDBJHy/Kre0wPLHx7IU6ePIa7x47CIw/fh30Hj8u4fYfGQJ3KaV5//XWxbpqXpzd4xPbnvyxAWblJJMeKju6GKY89LR9r6mjt8KWI5ohBwhUNXpoxVVj6p0+dhZqrLhIkh7/96lZQdMCnT33F/MHHizF50kSRlZ8y9UkDrbo6O0VpdaO5pUveNcdERYIDHqWl3ynuveqV/D97YVITMhR88AAAAABJRU5ErkJggg==",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5738",
    "data-name": "Trac\\xE9 5738",
    d: "M294.9,209.358a4.7,4.7,0,0,1,3.157,4c.545,5.634,1.428,11.984,1.466,16.064.03,3.238-.156,20.765-.208,25.483a1.521,1.521,0,0,1-1.147,1.458l-5.835,2.344-1,0Z",
    transform: "translate(-163.611 -0.33)",
    fill: "url(#linear-gradient-31)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5739",
    "data-name": "Trac\\xE9 5739",
    d: "M160.154,321.582H117.69v.945l42.2-.14Z",
    transform: "translate(-65.254 -63.898)",
    fill: "url(#linear-gradient-32)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5740",
    "data-name": "Trac\\xE9 5740",
    d: "M280.424,321.43l-12.373.03-2.989.771,12.374-.045Z",
    transform: "translate(-148.731 -63.812)",
    fill: "url(#linear-gradient-33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5741",
    "data-name": "Trac\\xE9 5741",
    d: "M293.64,312.962l6.5-1.842c.316-.05.542-.239.548-.46l.059-5.374c0-.077-.091-.14-.2-.137l-6.88.276Z",
    transform: "translate(-164.918 -54.59)",
    fill: "url(#linear-gradient-34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5742",
    "data-name": "Trac\\xE9 5742",
    d: "M300.66,304.507l0-.514H293.7l-.009.777Z",
    transform: "translate(-164.947 -53.935)",
    fill: "url(#linear-gradient-35)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5743",
    "data-name": "Trac\\xE9 5743",
    d: "M308.4,305.161l.5-.012c.114,0,.207.06.2.137l-.059,5.374c-.006.221-.232.41-.548.46l-.1.016Z",
    transform: "translate(-173.281 -54.59)",
    fill: "url(#linear-gradient-36)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22692",
    "data-name": "Groupe 22692",
    transform: "translate(19.642 219.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5756",
    "data-name": "Trac\\xE9 5756",
    d: "M46.454,246.294c.878-.891,6.075-7.082,6.885-7.986,3.137-3.5,5.309-5.351,4.931-5.761-.291-.316-4.906,3.977-5.775,4.946-1.021,1.139-5.769,6.229-7.023,7.419-2.24,2.126-3.6,3.775-3.4,4.012S45.315,247.45,46.454,246.294Z",
    transform: "translate(-42.051 -232.531)",
    fill: "#7f7f83",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5757",
    "data-name": "Trac\\xE9 5757",
    d: "M45.881,245.934c1.186-1.125,5.672-5.937,6.64-7.017.83-.927,5.134-4.95,5.4-4.658.352.379-1.677,2.126-4.625,5.416-.832.929-5.685,6.713-6.514,7.536-1.051,1.042-3.819,2.607-4,2.388S43.839,247.873,45.881,245.934Z",
    transform: "translate(-42.457 -233.501)",
    fill: "#848488",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5758",
    "data-name": "Trac\\xE9 5758",
    d: "M46.29,246.955c1.119-1.059,5.343-5.594,6.258-6.614.791-.883,4.784-4.638,5.034-4.369.325.349-1.561,1.992-4.32,5.071-.855.953-5.363,6.331-6.144,7.086-.961.93-3.449,2.345-3.615,2.144S44.445,248.707,46.29,246.955Z",
    transform: "translate(-42.864 -234.472)",
    fill: "#89898e",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5759",
    "data-name": "Trac\\xE9 5759",
    d: "M46.7,247.977c1.051-.993,5.013-5.251,5.875-6.212.753-.84,4.434-4.327,4.664-4.08.3.319-1.444,1.857-4.015,4.727-.876.978-5.041,5.948-5.773,6.635-.871.818-3.079,2.083-3.231,1.9S45.052,249.541,46.7,247.977Z",
    transform: "translate(-43.27 -235.443)",
    fill: "#8f8f93",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5760",
    "data-name": "Trac\\xE9 5760",
    d: "M47.108,249c.982-.927,4.684-4.908,5.492-5.81.714-.8,4.083-4.015,4.294-3.792.271.289-1.328,1.723-3.71,4.382-.9,1-4.718,5.566-5.4,6.185-.78.706-2.71,1.821-2.846,1.658S45.658,250.374,47.108,249Z",
    transform: "translate(-43.677 -236.414)",
    fill: "#949498",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5761",
    "data-name": "Trac\\xE9 5761",
    d: "M47.517,250.019c.914-.861,4.354-4.565,5.11-5.407.675-.754,3.733-3.7,3.923-3.5.245.258-1.211,1.589-3.4,4.037-.92,1.027-4.394,5.182-5.031,5.735a7.126,7.126,0,0,1-2.462,1.414C45.524,252.143,46.264,251.208,47.517,250.019Z",
    transform: "translate(-44.083 -237.385)",
    fill: "#99999e",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5762",
    "data-name": "Trac\\xE9 5762",
    d: "M47.926,251.041c.845-.8,4.025-4.222,4.727-5.005.636-.711,3.384-3.391,3.553-3.214.219.228-1.094,1.455-3.1,3.692-.942,1.052-4.069,4.8-4.66,5.285a6.125,6.125,0,0,1-2.077,1.171C46.254,252.835,46.868,252.04,47.926,251.041Z",
    transform: "translate(-44.489 -238.355)",
    fill: "#9e9ea3",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5763",
    "data-name": "Trac\\xE9 5763",
    d: "M48.334,252.062c.777-.732,3.7-3.878,4.344-4.6.6-.667,3.034-3.08,3.183-2.925.192.2-.978,1.32-2.795,3.348-.964,1.076-3.743,4.416-4.289,4.835-.5.38-1.6,1.036-1.693.927S47.473,252.874,48.334,252.062Z",
    transform: "translate(-44.895 -239.326)",
    fill: "#a3a3a9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5764",
    "data-name": "Trac\\xE9 5764",
    d: "M48.742,253.083c.708-.666,3.366-3.535,3.961-4.2a18.835,18.835,0,0,1,2.813-2.637c.165.168-.861,1.186-2.489,3-.987,1.1-3.416,4.033-3.919,4.385-.395.276-1.23.774-1.308.684S48.079,253.708,48.742,253.083Z",
    transform: "translate(-45.301 -240.297)",
    fill: "#a8a8ae",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5765",
    "data-name": "Trac\\xE9 5765",
    d: "M49.15,254.1c.64-.6,3.036-3.192,3.579-3.8a17.6,17.6,0,0,1,2.443-2.348c.139.137-.744,1.051-2.184,2.658-1.008,1.125-3.084,3.65-3.548,3.934-.29.178-.86.512-.923.44S48.684,254.542,49.15,254.1Z",
    transform: "translate(-45.706 -241.268)",
    fill: "#aeaeb3",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5766",
    "data-name": "Trac\\xE9 5766",
    d: "M49.555,255.126c.572-.535,2.706-2.849,3.2-3.4a16.682,16.682,0,0,1,2.072-2.059c.112.107-.628.917-1.879,2.313a37.678,37.678,0,0,1-3.177,3.484c-.179.087-.49.251-.538.2S49.287,255.377,49.555,255.126Z",
    transform: "translate(-46.108 -242.238)",
    fill: "#b3b3b9",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5767",
    "data-name": "Trac\\xE9 5767",
    d: "M49.937,256.147c.507-.467,2.377-2.506,2.813-2.993a16.72,16.72,0,0,1,1.7-1.77c.085.077-.512.783-1.574,1.968s-2.39,2.972-2.806,3.034a.174.174,0,0,1-.154-.046A.13.13,0,0,1,49.937,256.147Z",
    transform: "translate(-46.488 -243.208)",
    fill: "#b8b8be",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5768",
    "data-name": "Trac\\xE9 5768",
    d: "M5.188,273c4.367-3.6,14.684-9.092,14.684-9.092l.758-.05,2.223-.076a5.555,5.555,0,0,1-1.207,1.028c-.586.318-11.516,6.125-12.468,6.918s-1.916,1.787-1.916,1.787l-2.678.228A2.635,2.635,0,0,1,5.188,273Z",
    transform: "translate(-1.185 -31.16)",
    fill: "#fafafc",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22694",
    "data-name": "Groupe 22694",
    transform: "translate(2.49 240.162)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5769",
    "data-name": "Trac\\xE9 5769",
    d: "M2.873,287.823s4.322-.015,4.912-.521,2.664-6.1,2.007-6.132-5.411.946-6.395,2.389C2.524,284.841,2.148,287.394,2.873,287.823Z",
    transform: "translate(-2.49 -281.169)",
    fill: "url(#linear-gradient-37)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5770",
    "data-name": "Trac\\xE9 5770",
    d: "M2.873,287.823s4.322-.015,4.912-.521,2.664-6.1,2.007-6.132-5.411.946-6.395,2.389C2.524,284.841,2.148,287.394,2.873,287.823Z",
    transform: "translate(-2.49 -281.169)",
    fill: "url(#linear-gradient-37)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5771",
    "data-name": "Trac\\xE9 5771",
    d: "M2.873,287.823s4.322-.015,4.912-.521,2.664-6.1,2.007-6.132-5.411.946-6.395,2.389C2.524,284.841,2.148,287.394,2.873,287.823Z",
    transform: "translate(-2.49 -281.169)",
    fill: "url(#linear-gradient-39)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5772",
    "data-name": "Trac\\xE9 5772",
    d: "M10.025,281.169a5.521,5.521,0,0,0-.755.087A19.186,19.186,0,0,1,7.162,287c-.447.383-3.031.484-4.261.511a.47.47,0,0,0,.205.311s4.322-.014,4.912-.521S10.682,281.2,10.025,281.169Z",
    transform: "translate(-2.723 -281.169)",
    fill: "#fff",
    opacity: 0.524
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5773",
    "data-name": "Trac\\xE9 5773",
    d: "M5.018,285.526a11.094,11.094,0,0,1,4.815-3.3c.143-.622.171-1.053-.008-1.061-.657-.029-5.411.946-6.395,2.389-.851,1.25-1.182,3.731-.564,4.218C3.911,287.758,4.5,286.286,5.018,285.526Z",
    transform: "translate(-2.523 -281.169)",
    fill: "url(#linear-gradient-40)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5774",
    "data-name": "Trac\\xE9 5774",
    d: "M8.781,290.059c.038.65-.114,1.188-.337,1.2s-.436-.5-.473-1.153.114-1.188.338-1.2S8.744,289.409,8.781,290.059Z",
    transform: "translate(-5.591 -285.551)",
    fill: "url(#linear-gradient-41)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22693",
    "data-name": "Groupe 22693",
    transform: "translate(0.238 0.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5775",
    "data-name": "Trac\\xE9 5775",
    d: "M8.757,288.44c.224-.013.436.5.473,1.154s-.114,1.188-.337,1.2l3.139-.837.736-1.873Z",
    transform: "translate(-6.278 -285.242)",
    fill: "url(#linear-gradient-42)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5776",
    "data-name": "Trac\\xE9 5776",
    d: "M6.251,290.5c.037.65-.114,1.188-.338,1.2s-.436-.5-.473-1.154.114-1.187.338-1.2S6.214,289.854,6.251,290.5Z",
    transform: "translate(-4.397 -285.96)",
    fill: "url(#linear-gradient-43)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5777",
    "data-name": "Trac\\xE9 5777",
    d: "M10.134,281.55c-.04.28-4.558,1.782-5.459,2.433s-1.561,3.753-1.628,3.62.438-3.152,1.258-3.805A25.8,25.8,0,0,1,10.134,281.55Z",
    transform: "translate(-3.04 -281.53)",
    fill: "url(#linear-gradient-44)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22695",
    "data-name": "Groupe 22695",
    transform: "translate(35.478 209.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5778",
    "data-name": "Trac\\xE9 5778",
    d: "M78.582,218.621c-.365.9,15.6-2.033,23.4-2.667,6.044-.493,60.848-3.283,61.151-4.609s-54.924-2.234-64.507-1.631C87.006,210.446,80.391,214.156,78.582,218.621Z",
    transform: "translate(-78.576 -209.523)",
    fill: "#7f7f83",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5779",
    "data-name": "Trac\\xE9 5779",
    d: "M79.833,218.522c-.327.852,15.6-2,22.788-2.6,5.711-.5,56.358-3.213,56.616-4.481s-51.065-2.053-60.143-1.452C87.918,210.744,81.428,214.361,79.833,218.522Z",
    transform: "translate(-79.285 -209.672)",
    fill: "#838387",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5780",
    "data-name": "Trac\\xE9 5780",
    d: "M81.082,218.419c-.289.806,15.592-1.941,22.178-2.529,5.379-.48,51.868-3.144,52.082-4.353s-47.207-1.872-55.779-1.273C88.831,211.04,82.466,214.563,81.082,218.419Z",
    transform: "translate(-79.993 -209.816)",
    fill: "#86868b",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5781",
    "data-name": "Trac\\xE9 5781",
    d: "M82.332,218.312c-.251.759,15.587-1.9,21.567-2.46,5.046-.476,47.378-3.074,47.547-4.225s-43.347-1.691-51.415-1.093C89.743,211.33,83.507,214.762,82.332,218.312Z",
    transform: "translate(-80.702 -209.956)",
    fill: "#8a8a8f",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5782",
    "data-name": "Trac\\xE9 5782",
    d: "M83.582,218.189c-.213.713,15.582-1.854,20.957-2.392,4.713-.471,42.888-3.005,43.012-4.1s-39.49-1.527-47.051-.914C90.653,211.584,84.55,214.949,83.582,218.189Z",
    transform: "translate(-81.41 -210.081)",
    fill: "#8e8e93",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5783",
    "data-name": "Trac\\xE9 5783",
    d: "M84.832,218.068c-.175.669,15.577-1.814,20.346-2.322,4.381-.467,38.4-2.936,38.478-3.969s-35.631-1.348-42.686-.736C91.564,211.857,85.6,215.14,84.832,218.068Z",
    transform: "translate(-82.119 -210.207)",
    fill: "#929297",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5784",
    "data-name": "Trac\\xE9 5784",
    d: "M86.082,217.939c-.135.624,15.572-1.775,19.736-2.253,4.048-.465,33.908-2.866,33.943-3.841s-31.772-1.168-38.322-.557C92.476,212.124,86.649,215.325,86.082,217.939Z",
    transform: "translate(-82.827 -210.325)",
    fill: "#95959b",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5785",
    "data-name": "Trac\\xE9 5785",
    d: "M87.33,217.8c-.095.58,15.567-1.74,19.126-2.184,3.716-.464,29.418-2.8,29.408-3.713s-27.913-.986-33.958-.378C93.387,212.383,87.706,215.5,87.33,217.8Z",
    transform: "translate(-83.535 -210.433)",
    fill: "#99999f",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5786",
    "data-name": "Trac\\xE9 5786",
    d: "M88.58,217.649c-.052.536,15.561-1.709,18.515-2.115,3.384-.466,24.929-2.727,24.874-3.585s-24.054-.8-29.594-.2C94.3,212.632,88.773,215.674,88.58,217.649Z",
    transform: "translate(-84.242 -210.53)",
    fill: "#9d9da3",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5787",
    "data-name": "Trac\\xE9 5787",
    d: "M89.829,217.484c-.007.494,15.555-1.682,17.9-2.046,3.05-.473,20.439-2.658,20.339-3.457s-20.194-.619-25.229-.02C95.21,212.869,89.853,215.832,89.829,217.484Z",
    transform: "translate(-84.95 -210.612)",
    fill: "#a1a1a7",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5788",
    "data-name": "Trac\\xE9 5788",
    d: "M91.075,217.307c.044.451,15.547-1.662,17.294-1.977,2.715-.49,15.949-2.588,15.8-3.329s-16.334-.424-20.865.159C96.12,213.111,90.945,215.975,91.075,217.307Z",
    transform: "translate(-85.654 -210.682)",
    fill: "#a4a4ab",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5789",
    "data-name": "Trac\\xE9 5789",
    d: "M92.314,217.106c.1.4,15.537-1.652,16.683-1.909,2.375-.53,11.459-2.519,11.27-3.2s-12.474-.243-16.5.338C97.021,213.308,92.048,216.083,92.314,217.106Z",
    transform: "translate(-86.352 -210.729)",
    fill: "#a8a8af",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3277",
    "data-name": "Rectangle 3277",
    width: 3.434,
    height: 9.677,
    transform: "translate(132.658 238.008)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22696",
    "data-name": "Groupe 22696",
    transform: "translate(133.091 238.437)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3278",
    "data-name": "Rectangle 3278",
    width: 3.13,
    height: 8.792,
    rx: 0.946,
    transform: "translate(0 0)",
    fill: "#bd0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3279",
    "data-name": "Rectangle 3279",
    width: 3.13,
    height: 8.792,
    rx: 0.946,
    transform: "translate(0 0)",
    fill: "#bd0000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5790",
    "data-name": "Trac\\xE9 5790",
    d: "M304.506,280.665h2v-2.176h-2.021Z",
    transform: "translate(-304.153 -277.926)",
    fill: "url(#linear-gradient-45)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5791",
    "data-name": "Trac\\xE9 5791",
    d: "M308.98,279.577c0,.6-.245,1.088-.547,1.088s-.547-.487-.547-1.088.245-1.088.547-1.088S308.98,278.976,308.98,279.577Z",
    transform: "translate(-306.079 -277.926)",
    fill: "#e50000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5792",
    "data-name": "Trac\\xE9 5792",
    d: "M304.506,287.067h2v-2.176h-2.021Z",
    transform: "translate(-304.153 -281.552)",
    fill: "url(#linear-gradient-45)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5793",
    "data-name": "Trac\\xE9 5793",
    d: "M308.98,285.979c0,.6-.245,1.088-.547,1.088s-.547-.487-.547-1.088.245-1.088.547-1.088S308.98,285.378,308.98,285.979Z",
    transform: "translate(-306.079 -281.552)",
    fill: "#e50000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5794",
    "data-name": "Trac\\xE9 5794",
    d: "M304.506,293.469h2v-2.176h-2.021Z",
    transform: "translate(-304.153 -285.179)",
    fill: "url(#linear-gradient-45)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5795",
    "data-name": "Trac\\xE9 5795",
    d: "M308.98,292.381c0,.6-.245,1.088-.547,1.088s-.547-.487-.547-1.088.245-1.088.547-1.088S308.98,291.78,308.98,292.381Z",
    transform: "translate(-306.079 -285.178)",
    fill: "#e50000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3280",
    "data-name": "Rectangle 3280",
    d: "M.731,0h0a.731.731,0,0,1,.731.731V7.5a.731.731,0,0,1-.731.731h0A.73.73,0,0,1,0,7.5V.731A.731.731,0,0,1,.731,0Z",
    transform: "translate(1.532 0.348)",
    fill: "url(#linear-gradient-48)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5796",
    "data-name": "Trac\\xE9 5796",
    d: "M309.526,286.224h0a.288.288,0,0,0,.3-.267v-7.7a.288.288,0,0,0-.3-.267h0a.288.288,0,0,0-.3.267v7.7A.288.288,0,0,0,309.526,286.224Z",
    transform: "translate(-306.836 -277.645)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5797",
    "data-name": "Trac\\xE9 5797",
    d: "M304.012,277.19h.9a.414.414,0,0,0-.438.384V285.6a.414.414,0,0,0,.438.385h-.9c-.162,0-.293-.257-.293-.574v-7.644C303.719,277.447,303.85,277.19,304.012,277.19Z",
    transform: "translate(-303.719 -277.19)",
    fill: "#bd0000",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5798",
    "data-name": "Trac\\xE9 5798",
    d: "M133.292,309.868H68.049v-2.287h66Z",
    transform: "translate(-37.135 -55.968)",
    fill: "url(#linear-gradient-49)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5799",
    "data-name": "Trac\\xE9 5799",
    d: "M260.553,309.868h13.914v-2.287H259.791Z",
    transform: "translate(-145.745 -55.968)",
    fill: "url(#linear-gradient-50)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5800",
    "data-name": "Trac\\xE9 5800",
    d: "M20.262,304.409a11.454,11.454,0,1,1,22.907.146v2.538a.342.342,0,0,1-.341.342l-1.439,0a.342.342,0,0,1-.343-.342v-2.55a9.332,9.332,0,1,0-18.663-.139v2.026l-.578,0-1.544-.33Z",
    transform: "translate(-10.067 -47.683)",
    fill: "url(#linear-gradient-51)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3281",
    "data-name": "Rectangle 3281",
    width: 22.892,
    height: 38.916,
    transform: "translate(28.083 218.133)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22698",
    "data-name": "Groupe 22698",
    transform: "translate(25.17 218.758)"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5801",
    "data-name": "Trac\\xE9 5801",
    d: "M78.54,233.907l-8.265.033a5.144,5.144,0,0,0-3.635,1.525l-9.2,9.293a1.6,1.6,0,0,0,1.2,2.727l19.956-.817a1.285,1.285,0,0,0,1.232-1.284V235.192A1.285,1.285,0,0,0,78.54,233.907Z",
    transform: "translate(-56.03 -232.993)",
    fill: "#232628"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5802",
    "data-name": "Trac\\xE9 5802",
    d: "M59.408,247.671l19.956-.817a.677.677,0,0,0,.651-.678V235.984a.679.679,0,0,0-.679-.679l-8.268.033a4.507,4.507,0,0,0-3.207,1.345l-9.2,9.293a.967.967,0,0,0-.212,1.082.978.978,0,0,0,.912.613Z",
    transform: "translate(-56.821 -233.785)",
    fill: "url(#linear-gradient-52)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5803",
    "data-name": "Trac\\xE9 5803",
    d: "M58.448,247.059a1.029,1.029,0,0,0,.365.446l2.358-2.248.48,2.322,3.622-.149a6.121,6.121,0,0,1-.3-1.118c.075,0,.834-.095.834-.095l.3,1.179.473-.02s-.738-3.926-1.818-4.115a1.36,1.36,0,0,0-1.535,1.25c-.067.323-.115-.551-.138-1.083l5.512-5.254a4.152,4.152,0,0,1,.953-.681v9.762l.581-.024v-9.985a4.168,4.168,0,0,1,1.233-.221l8.647-.221v-.821a.679.679,0,0,0-.679-.679l-8.268.033a4.507,4.507,0,0,0-3.207,1.345l-9.2,9.293A.967.967,0,0,0,58.448,247.059Zm6.445-2.527c0-.095,0-.493.227-.265a4.774,4.774,0,0,1,.512,1.25h-.455S64.893,244.626,64.893,244.532Z",
    transform: "translate(-56.821 -233.785)",
    fill: "#a8b3af",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 24.765,
    height: 15.504,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3283",
    "data-name": "Rectangle 3283",
    width: 23.412,
    height: 14.151,
    transform: "translate(0.624 0.624)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22697",
    "data-name": "Groupe 22697",
    transform: "translate(11.293 2.016)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5804",
    "data-name": "Trac\\xE9 5804",
    d: "M80.847,248.212h.581V236.45l-.581.3Z",
    transform: "translate(-80.847 -236.45)",
    fill: "#232628"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5805",
    "data-name": "Trac\\xE9 5805",
    d: "M81.882,248.254h.132V236.948l-.132.086Z",
    transform: "translate(-81.433 -236.733)",
    fill: "url(#linear-gradient-53)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5806",
    "data-name": "Trac\\xE9 5806",
    d: "M80.979,248.67h-.132V237.794l.132-.111Z",
    transform: "translate(-80.847 -237.149)",
    fill: "url(#linear-gradient-54)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22703",
    "data-name": "Groupe 22703",
    transform: "translate(23.957 226.597)"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5819",
    "data-name": "Trac\\xE9 5819",
    d: "M57.971,251.2l.074,5.886a.277.277,0,0,1-.262.281l-4.972.263a.766.766,0,0,1-.584-1.3l5.271-5.316A.277.277,0,0,1,57.971,251.2Z",
    transform: "translate(-52.002 -250.472)",
    fill: "#232628"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22702",
    "data-name": "Groupe 22702",
    transform: "translate(3.209)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22700",
    "data-name": "Groupe 22700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5820",
    "data-name": "Trac\\xE9 5820",
    d: "M64.584,254.7h-3.5a1.677,1.677,0,0,1-1.677-1.677v-.29a2.849,2.849,0,0,1,2.849-2.849h2.331a.323.323,0,0,1,.323.323v4.17A.323.323,0,0,1,64.584,254.7Z",
    transform: "translate(-59.404 -249.882)",
    fill: "#282b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5821",
    "data-name": "Trac\\xE9 5821",
    d: "M64.7,254.713H61.239a1.628,1.628,0,0,1-1.628-1.628V252.8a2.8,2.8,0,0,1,2.8-2.8H64.7a.316.316,0,0,1,.316.316V254.4A.316.316,0,0,1,64.7,254.713Z",
    transform: "translate(-59.521 -249.948)",
    fill: "#26292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5822",
    "data-name": "Trac\\xE9 5822",
    d: "M64.81,254.728H61.4a1.58,1.58,0,0,1-1.58-1.58v-.277a2.757,2.757,0,0,1,2.757-2.757H64.81a.31.31,0,0,1,.31.31v4A.31.31,0,0,1,64.81,254.728Z",
    transform: "translate(-59.638 -250.013)",
    fill: "#24282a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5823",
    "data-name": "Trac\\xE9 5823",
    d: "M64.923,254.744H61.555a1.531,1.531,0,0,1-1.531-1.531v-.271a2.71,2.71,0,0,1,2.71-2.71h2.189a.3.3,0,0,1,.3.3v3.908A.3.3,0,0,1,64.923,254.744Z",
    transform: "translate(-59.755 -250.08)",
    fill: "#232628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5824",
    "data-name": "Trac\\xE9 5824",
    d: "M65.036,254.759H61.713a1.483,1.483,0,0,1-1.483-1.483v-.265a2.664,2.664,0,0,1,2.664-2.664h2.142a.3.3,0,0,1,.3.3v3.82A.3.3,0,0,1,65.036,254.759Z",
    transform: "translate(-59.872 -250.145)",
    fill: "#212426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5825",
    "data-name": "Trac\\xE9 5825",
    d: "M65.149,254.775H61.871a1.434,1.434,0,0,1-1.434-1.434v-.26a2.618,2.618,0,0,1,2.618-2.618h2.094a.289.289,0,0,1,.289.289v3.733A.289.289,0,0,1,65.149,254.775Z",
    transform: "translate(-59.989 -250.211)",
    fill: "#1f2224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5826",
    "data-name": "Trac\\xE9 5826",
    d: "M65.262,254.79H62.029a1.386,1.386,0,0,1-1.386-1.385v-.254a2.572,2.572,0,0,1,2.572-2.571h2.047a.282.282,0,0,1,.283.282v3.646A.282.282,0,0,1,65.262,254.79Z",
    transform: "translate(-60.106 -250.277)",
    fill: "#1d2123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5827",
    "data-name": "Trac\\xE9 5827",
    d: "M65.375,254.806H62.187a1.337,1.337,0,0,1-1.337-1.337v-.247a2.526,2.526,0,0,1,2.525-2.526h2a.276.276,0,0,1,.276.276v3.558A.276.276,0,0,1,65.375,254.806Z",
    transform: "translate(-60.223 -250.343)",
    fill: "#1b1f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5828",
    "data-name": "Trac\\xE9 5828",
    d: "M65.488,254.821H62.345a1.288,1.288,0,0,1-1.288-1.289v-.241a2.479,2.479,0,0,1,2.479-2.48h1.952a.269.269,0,0,1,.269.269v3.472A.269.269,0,0,1,65.488,254.821Z",
    transform: "translate(-60.34 -250.409)",
    fill: "#1a1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5829",
    "data-name": "Trac\\xE9 5829",
    d: "M65.6,254.837H62.5a1.24,1.24,0,0,1-1.24-1.24v-.235a2.433,2.433,0,0,1,2.433-2.433H65.6a.262.262,0,0,1,.262.262v3.384A.262.262,0,0,1,65.6,254.837Z",
    transform: "translate(-60.457 -250.475)",
    fill: "#181b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5830",
    "data-name": "Trac\\xE9 5830",
    d: "M65.715,254.852H62.661a1.191,1.191,0,0,1-1.191-1.191v-.229a2.387,2.387,0,0,1,2.387-2.387h1.858a.256.256,0,0,1,.255.255v3.3A.256.256,0,0,1,65.715,254.852Z",
    transform: "translate(-60.574 -250.541)",
    fill: "#161a1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5831",
    "data-name": "Trac\\xE9 5831",
    d: "M65.827,254.867H62.818a1.142,1.142,0,0,1-1.142-1.142V253.5a2.341,2.341,0,0,1,2.341-2.341h1.811a.249.249,0,0,1,.248.249v3.209A.248.248,0,0,1,65.827,254.867Z",
    transform: "translate(-60.691 -250.606)",
    fill: "#14181a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5832",
    "data-name": "Trac\\xE9 5832",
    d: "M65.941,254.883H62.977a1.094,1.094,0,0,1-1.094-1.094v-.217a2.294,2.294,0,0,1,2.294-2.294h1.763a.241.241,0,0,1,.241.241v3.122A.242.242,0,0,1,65.941,254.883Z",
    transform: "translate(-60.808 -250.673)",
    fill: "#121618"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5833",
    "data-name": "Trac\\xE9 5833",
    d: "M66.053,254.9H63.134a1.046,1.046,0,0,1-1.045-1.045v-.211a2.249,2.249,0,0,1,2.248-2.248h1.716a.235.235,0,0,1,.235.235v3.034A.235.235,0,0,1,66.053,254.9Z",
    transform: "translate(-60.925 -250.738)",
    fill: "#101416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5834",
    "data-name": "Trac\\xE9 5834",
    d: "M66.166,254.914H63.292a1,1,0,0,1-1-1v-.205a2.2,2.2,0,0,1,2.2-2.2h1.668a.228.228,0,0,1,.228.228v2.947A.228.228,0,0,1,66.166,254.914Z",
    transform: "translate(-61.042 -250.805)",
    fill: "#0f1215"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5835",
    "data-name": "Trac\\xE9 5835",
    d: "M66.279,254.929H63.45a.948.948,0,0,1-.948-.948v-.2a2.156,2.156,0,0,1,2.156-2.156h1.621a.221.221,0,0,1,.222.222v2.859A.222.222,0,0,1,66.279,254.929Z",
    transform: "translate(-61.159 -250.87)",
    fill: "#0d1113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5836",
    "data-name": "Trac\\xE9 5836",
    d: "M66.393,254.945H63.608a.9.9,0,0,1-.9-.9v-.192a2.11,2.11,0,0,1,2.11-2.11h1.574a.215.215,0,0,1,.215.215v2.773A.215.215,0,0,1,66.393,254.945Z",
    transform: "translate(-61.276 -250.936)",
    fill: "#0b0f11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22701",
    "data-name": "Groupe 22701",
    transform: "translate(0.144 0.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5837",
    "data-name": "Trac\\xE9 5837",
    d: "M62.712,252.45c-1.435.972-2.612,1.225-2.853.888s-.236-1.3,1.013-2.713c.664-.752,3.633-.759,3.875-.421S63.859,251.673,62.712,252.45Z",
    transform: "translate(-59.735 -249.989)",
    fill: "#fff",
    opacity: 0,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5838",
    "data-name": "Trac\\xE9 5838",
    d: "M62.894,252.371c-1.354.911-2.463,1.141-2.689.815s-.215-1.235.964-2.561c.63-.7,3.421-.7,3.647-.378S63.978,251.642,62.894,252.371Z",
    transform: "translate(-59.936 -250.016)",
    fill: "#fff",
    opacity: 0.063,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5839",
    "data-name": "Trac\\xE9 5839",
    d: "M63.076,252.29c-1.272.851-2.315,1.057-2.526.742s-.2-1.175.916-2.408c.595-.659,3.208-.649,3.42-.334S64.1,251.61,63.076,252.29Z",
    transform: "translate(-60.137 -250.041)",
    fill: "#fff",
    opacity: 0.125,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5840",
    "data-name": "Trac\\xE9 5840",
    d: "M63.257,252.21c-1.19.79-2.166.972-2.362.669s-.178-1.112.867-2.255c.561-.613,3-.594,3.192-.291S64.214,251.578,63.257,252.21Z",
    transform: "translate(-60.337 -250.067)",
    fill: "#fff",
    opacity: 0.188,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5841",
    "data-name": "Trac\\xE9 5841",
    d: "M63.44,252.129c-1.109.729-2.018.888-2.2.6s-.158-1.05.818-2.1a3.686,3.686,0,0,1,2.965-.248C65.205,250.666,64.333,251.546,63.44,252.129Z",
    transform: "translate(-60.538 -250.092)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5842",
    "data-name": "Trac\\xE9 5842",
    d: "M63.621,252.047c-1.029.666-1.869.8-2.035.525s-.138-.988.77-1.951a3.355,3.355,0,0,1,2.737-.2C65.26,250.7,64.45,251.511,63.621,252.047Z",
    transform: "translate(-60.739 -250.117)",
    fill: "#fff",
    opacity: 0.313,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5843",
    "data-name": "Trac\\xE9 5843",
    d: "M63.8,251.965c-.948.6-1.721.72-1.872.452s-.119-.925.721-1.8a3.025,3.025,0,0,1,2.51-.161C65.314,250.726,64.568,251.478,63.8,251.965Z",
    transform: "translate(-60.94 -250.142)",
    fill: "#fff",
    opacity: 0.375,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5844",
    "data-name": "Trac\\xE9 5844",
    d: "M63.985,251.883c-.866.544-1.572.636-1.708.379s-.1-.862.673-1.645a2.7,2.7,0,0,1,2.282-.117C65.368,250.755,64.686,251.443,63.985,251.883Z",
    transform: "translate(-61.14 -250.165)",
    fill: "#fff",
    opacity: 0.438,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5845",
    "data-name": "Trac\\xE9 5845",
    d: "M64.167,251.8c-.785.483-1.424.551-1.544.307s-.079-.8.624-1.493a2.375,2.375,0,0,1,2.055-.074C65.422,250.783,64.8,251.408,64.167,251.8Z",
    transform: "translate(-61.341 -250.188)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5846",
    "data-name": "Trac\\xE9 5846",
    d: "M64.348,251.715c-.7.421-1.275.467-1.38.234s-.059-.737.575-1.341a2.053,2.053,0,0,1,1.828-.03C65.476,250.81,64.921,251.371,64.348,251.715Z",
    transform: "translate(-61.541 -250.21)",
    fill: "#fff",
    opacity: 0.563,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5847",
    "data-name": "Trac\\xE9 5847",
    d: "M64.529,251.629c-.622.36-1.127.383-1.217.162s-.038-.675.527-1.188c.322-.292,1.51-.209,1.6.013S65.039,251.334,64.529,251.629Z",
    transform: "translate(-61.741 -250.23)",
    fill: "#fff",
    opacity: 0.625,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5848",
    "data-name": "Trac\\xE9 5848",
    d: "M64.71,251.541c-.54.3-.978.3-1.054.09s-.017-.612.479-1.036c.288-.246,1.3-.153,1.373.056S65.156,251.294,64.71,251.541Z",
    transform: "translate(-61.941 -250.249)",
    fill: "#fff",
    opacity: 0.688,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5849",
    "data-name": "Trac\\xE9 5849",
    d: "M64.891,251.451c-.459.238-.83.215-.89.017s0-.549.43-.883c.255-.2,1.085-.1,1.145.1S65.273,251.252,64.891,251.451Z",
    transform: "translate(-62.14 -250.265)",
    fill: "#fff",
    opacity: 0.75,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5850",
    "data-name": "Trac\\xE9 5850",
    d: "M65.07,251.357c-.377.177-.681.131-.726-.055a.727.727,0,0,1,.381-.731c.222-.154.873-.043.918.143S65.389,251.207,65.07,251.357Z",
    transform: "translate(-62.339 -250.277)",
    fill: "#fff",
    opacity: 0.813,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5851",
    "data-name": "Trac\\xE9 5851",
    d: "M65.249,251.258c-.3.117-.533.046-.563-.128a.574.574,0,0,1,.333-.578c.19-.107.66.012.691.186S65.5,251.157,65.249,251.258Z",
    transform: "translate(-62.536 -250.285)",
    fill: "#fff",
    opacity: 0.875,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5852",
    "data-name": "Trac\\xE9 5852",
    d: "M65.424,251.151c-.212.057-.384-.038-.4-.2a.419.419,0,0,1,.284-.426c.16-.058.448.067.463.23A.445.445,0,0,1,65.424,251.151Z",
    transform: "translate(-62.731 -250.285)",
    fill: "#fff",
    opacity: 0.938,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5853",
    "data-name": "Trac\\xE9 5853",
    d: "M65.832,250.756a.238.238,0,1,1-.235-.273A.256.256,0,0,1,65.832,250.756Z",
    transform: "translate(-62.922 -250.269)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22704",
    "data-name": "Groupe 22704",
    transform: "translate(43.205 236.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5854",
    "data-name": "Trac\\xE9 5854",
    d: "M102.261,274.466a1.281,1.281,0,1,1-1.281-1.281A1.281,1.281,0,0,1,102.261,274.466Z",
    transform: "translate(-98.268 -273.185)",
    fill: "url(#radial-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5855",
    "data-name": "Trac\\xE9 5855",
    d: "M101.734,276.048H96.827a.429.429,0,0,1-.429-.429h0a.429.429,0,0,1,.429-.429h4.907a.429.429,0,0,1,.429.429h0A.429.429,0,0,1,101.734,276.048Z",
    transform: "translate(-96.398 -274.321)",
    fill: "url(#linear-gradient-55)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22705",
    "data-name": "Groupe 22705",
    transform: "translate(56.698 218.654)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3284",
    "data-name": "Rectangle 3284",
    width: 31.633,
    height: 15.712,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3285",
    "data-name": "Rectangle 3285",
    width: 27.158,
    height: 11.238,
    transform: "translate(2.289 2.289)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQUAAABsCAYAAABjGqe3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAABBaADAAQAAAABAAAAbAAAAAAnEp0WAAAPa0lEQVR4Ae2dW2wV1RrHv7177+6F3qA3WgpiK0XKUYMYfPH25rMJCXg53sIBwnnQI5JICE/Ho0FM8JiAiYkaX3w0Gh80PCgJKNFwNEUilAr2fsPedm90n/V9w5qZvWe69y67CF3zn2T2zKxZs2a+36z591vfWjMNxWIxymQKhUKxmpoaKisrk3nv3r00NjaWskh1XMo8qTJkWkamx/P1ZVrG7T4eNli1bDnfh+eff54ikYjMHR0dGT9Y2RaSxf0qgKIk27Zto6KiIjl4y5YttHXrVlq1apVspwv5duS7HedkKEt53qUsa6mvbanLM8HWW2nDCy+8QGfPnmXs9PDDD8dOnTolzyU/mz09PYsWiVC6noIyKs6lOHr0KL388styIePj4zQzMyMzJ+Tk5Ej6rfmJu4wFT5GhA7RguYvfgetdPLN0jwBbTaq0tISysrIoLy+furu7ad++ffTDDz9Qb2+vZFHPedrikJYoaEHgE+3Zs4fq6+tpeHhYRGBsbJSi0SmamorKkq8gEinU10qLezhvxU1eDmWmd40MNX2eKNOuhElWbh/P9O9POve9qqqScnPzqKuri5qbmykcDhM367/55hs6dOgQnTlzRpr36rlNKQ5JRUGLAV9Ue3s7NTQ00MDAgAhCNMoiEKXz59upvLyCRkaGVfqI4F+zplGW/ONA90IwZ5/XNsd27LMrw40V674vxMU/3eKJff4sifLz86ilpUV56bnKW8ilqqqVVFxcrIQiVz2f5bR//3766KOPRBguXbqUVBgWFAUWhKamJqqtraWTJ09SX18fjY6yVzBJk5M8W4IwOjomnsHs7Kw68etJT5ZoELZBAAQyJ3D48OE4tSwqilBr60YqKSmhiYlxuuuu9VRdXU2nT58mDkqqYKScdKEmha8osCBwEPHZZ5+lHTt2SLvk6tWrIgZc2sWLv4mX8Morr0IEMr+nKAEElpzAW2/9J8Z/0DnwHw5nUWVlpTQnKioqiDsF8vPzJTg5NTXleYY9oqCbDF9//TWtX7+e5ufnJXDB3Yy//94pQcTnnvu7p6AltwoFggAIZEzgxInjsYaGRiUMIdWcKKHVq+upoqKSHn/8ceJeCj9vwVcUnn76aTp+/Lg0Gc6fP69iBUMSR9i9ew/EIOPbhAJA4K8l8O67R2MsCHV1dXJiDkRyZwEHIjnukDi2Iey+PO0lfPDBBypwOEIqIKGimX/Qb79dJAiCmxTWQWD5ENi375+hvr5e6YHgq56YmJD44GeffSZGtLW1xcUkbFHQgsBiMD4+Rp2dl6XLkQOMBw8ehIewfOoArhQEPARef/2APMMcD1RxBBEFHmz46KOPevLazQcWhRMnTtATTzxBg4MDah5SbsUl2rXrHxAEDzYkgMDyJMA9FQ8++KAa8RihxsY1EoAsKCiQZoTqXZRnXTwF7SXs3LlTLE3n3YXliQRXDQLBJsBeP49y5AGH166NSM8iOwPuyW4+bN++XYKJ/f19sp/dDHgJblRYBwEzCDzzzDOhy5c7VLywWwzioQcccFSDnyS2YIuCcitoenpaMl24cAGBRTPuP6wAAV8C+lkfGhqS0ciPPfaYnS/MTYfdu3fLcMihoUEZqtzX129nwAoIgIB5BPbs2Rvq7++XQYgzM7N04MAB8RbYUttTyM7OUt9BGKeffvrRPAKwCARAwEPgjz+uyouM3F3JIxzPnTsneeR7Cps3b7YPKC0tRSzBpoEVEDCXwOzsnDgC/EIjvxvBcQVuOYgo3HfffWpMwqwdUzAXAywDARBwE7A+fRCVwYr8URYe5SjNh02bNskr0Zx5YGDQfQzWQQAEDCbAbznzJxD4LWcdbAzz25Bzc3PSHclDmpfg04kGI4RpIGAOAR6zwJ7C9evX5cVHa1BTEYX159i0GKg2hTlWwxIQAIGkBDiuoCf+nBt/ocklCiwGobQ/LqoLwhIEQMAsArYoWIJglnGwBgRAYPEEbFGwWg3wFBaPEEeAgFkEbFHQngJiCmbdYFgDAskINDY2eHbboqDjixAFDyMkgICxBLjnMXGScQosBO45MRO2QQAEzCTg7n3QFtqeAjcfrEkvdRYsQQAETCUwNzfrMc0WBSfQ6MmDBBAAAUMJcPOhsLBA3pLWJtqigECjRoIlCASHAA9vnpuzRjRqq21RQKBRI8ESBIJDgD0FPcxZBx1douAEG4ODBJaCQLAJuEUhO1temnaGOetAI7okg11JYH2wCDj/5Nmx2+UpcCJ6Hhw0WAOBYBIQUXD3PMBTCGZFgNUgoAnc8BQ4nmAlQRQ0GixBIJgE7A+3Wl2SeCEqmNUAVoOAQ8AVU7BcBXgKDhysgUAQCbhEgc1nYUCwMYgVATaDgCZgi4LVfFC/0ATNBksQCCQBWxScHgioQiBrAowGgRsEbFFwPAWIAmoHCASZgC0KHGAcGRkJMgvYDgIgoAi4RIHjCSEaGhoGGBAAgQATEFGYn59XCLjZgKZDgOsCTAcBIZDgKYAKCIBA0Al4RjQGHQjsB4GgE0jwFNB8CHqFgP0gYIuC1SUJUUCVAIGgE7BFgXse8N5D0KsD7AeBhC5J9D6gSoAACNiegtV8ABAQAIGgE7BFgd99QPMh6NUB9oOAq/mAQCOqAwgEj0BT0xqP0S5PAYFGDx0kgIDhBGI+n3O2By9x8wGBRsNrAMwDgQQCvqLgJMJTSOCFTRAwnoDz/DumupoPHGh0dmANBEDAfAJJRQGBRvMrACwEgUQCSUUBIxoTcWEbBMwnkEIUuPmA9oP51QAWgoBDIKkoWD0PEAUHF9ZAwHwCSUUBIxrNrwCwEAQSCSQVBSvQmHgItkEABEwmkFQUEGg0+dbDNhDwJ+ArCu6sCDS6aWAdBMwn4CsKOhGegvkVABaCQCIB/fy70+NGNFo9EO7dWAcBEDCZQFJRQKDR5FsP20DAn0BSUUCXpD80pIKAyQRYFIqKInEm2s0Hy1PA4KU4OtgAAcMJsCjwJxXy8vJsS21RQKDRZoIVEAgMAUsUWBiUMtyYXKLAKfAUNBgsQSAIBCwxcASBbbZFgTcwToEpYAKB4BDQngKRIwy2KHR2/o6PrASnLsBSEBACligoSXA0gexvNHIOeAqoKSAQLAJO88FRBdtTYBQQhWBVCFgLArr5EOcpWEphwYEooJKAQLAI6OaD2+o4TwG9D240WAcB8wk4ngKaD+bfbVgIAmkQsFoKjiDwIXGeAj7RmAZFZAEBgwi4PYW5uTmxLEEUMHjJoPsNU0AgJQF3TEHHFCEKKbEhAwiYS0B7Cr6Dl9js7u5uc62HZSAAAh4COqbAXZK+ngJ6HzzMkAACRhNwPAWXKLgtRqDRTQPrIGA+AR1T4KXtKWzbtk028vJyqa6ungoLC8wnAQtBAATo8OHDsbq6OpvEL7/8IuvhaDRKIyMjtGZNkySUlJTYmbACAiBgNgHdDVlWVkZnz56l3NxcCo+Pj9Ovv/5qtuWwDgRAwJdAcXExVVVVypeXTp06RTMzMxQeGxujixcv2geEw2FxK+wErIAACBhJoLy8jMrLK8S2rKwsWarYQkg8Bd5iMWDXIScnR6lGrmTADwiAgLkEJicnxUOorq4h9hL0FN60aRMdO3aMqqurqampSS1r4j7iqDNiCQIgYA4BDjKyNTMz08RxBR1k5LTwd999J2Obv/zySyouLqL8/Dy6554N9P77/41/S4JzYwIBEDCGQFvbZvni0vz8PH366ae2XfLlJY4rvPTSSxSJFImnwHtzc51PPtu5sQICILDsCbCXwMFFnpqbm2nFihUSPtCGiSh0dHTQwMAAZWdnS9Nh1apVtG7dWgQcNSUsQcAgAiUlxbR27TppGXDY4Mknn5TuSA4yspkiCrzBg5h4rqmpEeXIzy9QzYgWCINBlQGmgICOJXBnAgvD6dOnJcg4PT1tw7E/3MrRx++//16CjpFIRMUW8qmkpFT6MO3cWAEBEFi2BFgQuHeRY4br1q0jHrD0yCOPiD3aS+CNkNqwjdywYUOM4wsnT56UpsT09BRduHCBhoaGaHBwkF599V/iXtgHYAUEQGBZEHjnnSMxHqi0enWDxBH4or/66ivatWsX/3eouOfa9hQ4U3t7u+x84IEHpIsyLy9fmhK1tXW0cuVKeu+9Y46C8AGYQAAE7ngCR44ciW3Y0Ep3390sgsCtgM7OTvrkk098rz3OU9A5VDQy9vbbb9POnTtpeHiYurq66Nq1a3T9+nX1zYUu6u/vp9de2x+nLvpYLEEABO4MAm+++e8Y9yzwe03cVOA/7CwI3377LT311FNykYleAif6ioIa8hh76KGH6M8//5QCWAy4WdHb26PSRqWwn3/+H01ORungwYMQByGCHxC4/QQ4bhCJFNLEBI9WzKXNm/9GlZUVVFFRKd4/ewcvvviiXKifIPAOX1HQpt17770xfoPy0KFDtGPHDiUKvUoIJtQ8qeIMw3TmzBnJunJllfIeBvRh6lVsezXjFf2Od8YFqQLu1LLUlS0hs2CUxfVh6erZncsslZ3j4xOcRT55UFBQQHrmP+hNTWtVt2Mx1dbWiiB8/PHHMh6J8y8kCLwvqShwhvr6ehGGrVu30hdffCFBR45gcvDxypUrMgJyasrqzohGJ4nHPDiTH2y/tIUe2Ezz3prj/R9iv3P5pTEdv3T/NMntEVn/vN6HxDrQL90vzXuuTI+/dbYu/bUubCufi4Pumd03v/LTTRNrfUQwRJcvX1Y7Y9TaulGaBjwimZsIpaUr+CARA+525F4GHnLAvYzJBIGPSSkKnEl1UcbYO2htbaX777+f3njjDRYL8Rx4P08sCFeuXLU2bvx6Kx7vsEC4M6aT707LI5Z4TPEk+N5It+03X44cGVfUUjG6+Wv6K+33nst73enk8XL0lnNr83jPl851W3nYe+eJhaCxsVE9q4Wq5zBHPAYejLhlyxbq6emRZzWVGEhB6ictUdCZN27cKOIwMWE1IT7//HMJXrS0tMh72PoCdf74SupvqM7Ly+DmT80mns9yzr+cr13uAv+knJy6vBh708vLJ7fKD4nHzts8MpHjfh9++CGp3gaampqSmXsS0/EOuAw9LUoU9EG8VG2VWFtbG42OjkpAkpfsSSROSp0Sk9h9iUtL3Oad6aQtVR6/86VT9l99HK4pvXpxs/dlOfLlZ5Cb8Q0NDcQfTNJzX19fymYCc/KbbloU/ArjZgZ/lyFx8oOdmCedbZSTnBL4ZMansLDQ88cokal7273OZ062nWxf4rGLycvXzE17dUz6bkZyTPR/pIOktWU69SIAAAAASUVORK5CYII=",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22706",
    "data-name": "Groupe 22706",
    transform: "translate(93.43 218.654)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3286",
    "data-name": "Rectangle 3286",
    width: 31.633,
    height: 15.712,
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_3287",
    "data-name": "Rectangle 3287",
    width: 27.158,
    height: 11.238,
    transform: "translate(2.185 2.289)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQUAAABsCAYAAABjGqe3AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAABBaADAAQAAAABAAAAbAAAAAAnEp0WAAAQIklEQVR4Ae2dW2wV1RrHv16g94sttFRuRSigQOFooiI+GGOiMfHFJx98KBiPkJiIJxHxJBJDzDFHDXdfMCbEYI7G+OiTJvpCIgSJCMitQNML9Ar0Qm+03Wf+33TNnr1n9u70gtCZ/yR7z5o1a9ae7zdr/v3Wt9ZMM2KxmEx3ycjIcCrZtGmT1NXVOVVa+5y0O5EqH2VS7btf+ffznAYHB93YPOlUTDwF02RMt477fTxMu9/nMN3fn64Nr732mnOFrXva/6ZzSqRPZExFFCwAKgIQgGPHjukvIF1TUyNPP/20lJaWBr5IQWHOZLmZrAvG36v6BgYG0tad6ndnS346dvfahuzsbG236b5SnUPyMUHKBSmTjsdEv7l37145c+aMFBUV6ef06dNSWFgoN27cmLRATEoULMNi8+bNE3zKy8vlyy+/lLy8PCkuLpaRkbty9+6I9bkrc+bMSbZhBrcdpyRtnTPgAKWtP/hOnm9wVpMtSbbJxKqqqgR/6I8ePSoffvihFBQUSH5+vn5+++23QAIRSBQgBubHIQToHnR1daoAXLhwUSorK2RgYFAGBwd0XVCQb4pbJ+gkAySCFQ5fncHsBsDgtrPOAA3uPvIMfn2CXvf58+fJ3Lk50tLSIo8++qhUVFRIT0+PfPTRR3Lq1Cm5dOmS3Lx5c0JhmFAUjCC88cYbcujQIent7ZE7d/qlo6PdEoEhGRoawg9pfm9vr3USvVJdvdS5HvFG7IUQnn1e2+IXkvucxjCesK97Ki7++TZP7vNnKZKdnWV9smX16tWWpz5XPfjKykopKSmR4eFh9R6eeOIJyc3N1X1XrlxJKQ5pRcEIwg8//CAvv/yydHZ2qvL09HRLd3ePnD17RgWiqKjQ6j6M6OeDD/6d8seSDeI2CZDAzBDYvXu3o5iFhQWybNkyWbCgyhKBHMnJydXuw6JFi+S5557TOCAE4uTJk773akpRMIJw69Yt7RbAK2hqatIuQ0tLsyUGd2Tr1m2+lc6MmayFBEhgqgQ+++zT2MMPP2x17StldHRMxWHp0mpB3uHDh+XIkSPy+++/w4Pw3MO+omAEAdHvixcvSlZWluWCDFldhk65fr1FNm/e4qloqifP40iABO4dgU8++U8Mgf9162qt+zhTVqyosboX2XL5cr289NJLOlLR0dGRcD97RMEIQltbm+UhDMr58+elublJh8YQtNi+/d2ECu6dOayZBEhgpgjs379PRw4xOoGRw1WrVsvOnTvlm2++0bCA22PIdP+oEQSMMIyNjUlDQ4Pubm9vt4ShhYLghsU0CcwiAu+8sz2jsbFRrl69Jq2tbdanVT7//HP1FGpraxMsSRAF7HnxxRfl9ddfVy8B3Ye//jqnB+zatYseQgI6bpDA7CKAQYDr16/rSXd1dVnTCrp0mBIZxiHQNCY6uDMhBFARHIwhRojCu+/+i4KglPhFArOfwLff/i+2ePFiy0solrKyMiu+cFmef/55J+iY4CkcOHBAMNrQ0HBNBeHChfMUhNnfBmgBCSQQuHTpstTXXxGEBTCVYOPGjdqNWLhwoXoIKgrGddi2bZtzcH39ZUE/xMlgggRIIBQEEArAaOLo6KhOM8CAwpYtWxzbHE8BDzRBNRBcHBoa1tlRTikmSIAEQkXgzTf/mXH58iXp7++X27dvO0FHOAiOKHz88ccaS8CwI4Yg29raQwWBxpAACSQSwCMKWJqbm9UhwBOWcA4cUXjmmWfUS0AhazKDcLQBJLiQQHgJ4JmIGzeu64xlDC689dZbcuLEibgowPT8/DxrHPNKeCnQMhIgAYcAhigbG5t0GjQyV6xYoQHHTBNkRN8CS3Exnqq6q2l+kQAJhJsAhiTNsmHDBn0xi3Yf0I/AcuvWbSvwcMeU4ZoESCDkBPAqBCx4BwNexoK4QiYEoc56aQoikFjw8FOK1yrqfn6RAAmEhwDeloannvv6+vTRBrzCLRMzGvGxuhGOGCDNhQRIIBoEzKxmzFs4fvx4XBRgvi0GEAeKQjSaA60kAdHXtoEDHoLEop6CpvQrQ4co4ttMkQAJhJ0AuhB4K1OCKLi7D/AS8KYWLiRAAtEggDexo+vgEQXbfHYdotEMaCUJxAng8QaPKGA3wgj2h/GEOC6mSCD8BPC/WiAKsdh4TAEm29FH20tgkDH8jYAWkoCbgO0pjKTuPlj+grs80yRAAiEngECj3X2wX7jkjD7Euw8hJ0DzSIAEHALFxUXWE5IpA43wEBhodGgxQQIRIIB4Ap53GhlJMfrAQGMEWgFNJAEXAcQTxsZG040+0FNw8WKSBEJPwBaFMa8omNEHdh9C3wZoIAkkEBh/mXtCnvNAFHLRfeBCAiQQLQJGGPB/J7EkjD7QU4hWY6C1JGATsIcizdOSLk8B8QR4C3QX2FRIIEoEjKdgbNY3LxmFoKdgsHBNAlEiYHsK1txmNdrVfeA05yg1A9pKAobAggVVmjQeg6v7YAKN7D4YWFyTQBQIxHsKtrUJomB3H6KAgTaSAAkYAkYUzDqp+8BAowHFNQlEhYB5ZNrY6+MpsPtg4HBNAlEgYDwEs3ZEwQxHckgyCs2ANpJAnIARA5PjdB9MPIGiYNBwTQLRIGBEwawdT8E2H10Hdh+i0RRoJQnYBIwYGB6OKJiJjGZtCnBNAiQQbgIeUYibmyHd3d2c5hwHwhQJRIIARAH/98GIg+MpGOsZUzAkuCaBaBCwxcBMdR5/ShKZ5l/RUxSi0RBoJQkYArj/McU5wVMwO7GmKLhpME0C4Sdgi4KPpxA3naMPcRZMkUD4Cdgegv3f52Gta56CbTxHH8LfCGghCbgJTOgpsPvgxsU0CYSfgC0KsNP1PgXbfbCNpyiEvxHQQhJwEzCeAoKNWHy6D4wp2Gj4TQLRIGA7Ba5AI8x2ewqc5hyNhkArScAQsD2FuA5w8pIhwzUJRJSA6T4Y8326D2YX1yRAAlEgYLoPpsdATyEKV502kkAaAr6eglEIHMfRhzT0uIsEQkjAFgUY5hqSdNtJUXDTYJoEwk/AeAoJQ5JuT4GjD+FvBLSQBNwE7PvfNSRpVMIUoqdgSHBNAtEgYDTAOAee0Ydbt25GgwStJAESUAK2KMRheEYf4ruYIgESiAIBj6cAo43bgDS7D6DAhQSiQ8C+/5NiCtExn5aSAAkkE4h3H1xDkm5PgaMPyci4TQLhJmCLgv1KNljqiSnwJSvhbgC0jgSSCcS7Dy5PIbkQt0mABKJDIICnwPcpRKc50NKoEygtLdGBBjObETw83YeoQ6L9JBAlAvASysrKxoUhZfeBnkKUGgVtjTYBu+sABklDknagwYbDQGO0GwmtjxYB+943r3d3eQpuUYgWElpLAtEmYDwFxBRMXCEzGQlnNCYT4TYJhJeA8RTs7gM9hfBeaVpGAgEJxD2FtJOXGGgMyJPFSGDWEzCeguk6wCDPo9Oz3koaQAIkEJhAoqfg6j4k1kBPIZEHt0ggvASMp+AZkly1apVjNYckHRRMkEDoCQT0FELPgQaSAAmMEzCeQtqYAock2V5IIDoE3J6C6UIw0Bid609LScBDwHgKEATjLfiIAgONHnLMIIGQEkj0FGwjfWY0htR6mkUCJOAhYDwFeAl22pqnsGnTJjl58qRkZ2dLTs5cuXmTr3j3kGMGCYSUAMRg4cJFMm9euSxYsECtzBwYGJBffvlF5syZI3l5eVJcXBxS82kWCZBAKgLl5fOkublZd2efOnVKEyUlJSoKRUXF0tralupY5pMACYSIQHl5mWPNr7/+qmkEGjOqqqp0Iy8vX9/C4pRiggRIINQEcnPROyiS/Pw8+fnnn9VWDTTu3r3biifk6Gfu3LkaWwg1CRpHAiQgn37639jAQL8MDQ3LyMiofPfdd0pFReHIkSNy8ODB8bhCrmzY8A/Zt2+v/XQE4ZEACYSSwODgkKxcuVJtKy8v1zV6DioKfX19sn//fnnooYc0roC98By4kAAJhJOA1TuILVq0UCcsVVdXS39/v2OoisIff/yhM5YQfSwpKZXCwgJ55JHl8tVXX9FbcFAxQQLhIQBBwFAkHAG8zfmVV15xjFNRwFZvb6/U1dXpkGRBQaHGFTBvgQsJkEC4CJjQQGlpqVRUVEh7e7scO3bMMTJBFLADBVAQUcn58ysEboZTmgkSIIFZTQD388DAoNUTeEQqKystb2Gh1NTUqE2IJyDhiII1iSnjySeflFdffdUSg/k6uwkHbdiwnsIwq5sBT54E4gQwL+Hxxx/XP/pZWZny008/6U4jCNjIsDbiR1ipxx57LIY+BsYsW1tb5c8/T0tXV5d0dnbKe+/t4NNSCbS4QQKzh8DBgwdiK1euEsQTECLAtGbMYsbiFgXHUzCmIbZw9uxZOXr0qGYtXVoty5cvl9ra9fLFF4cSFcQcxDUJkMADS2DPnj2xw4cPx9auXWcFFksdQXjhhRf0nN2CgIzsZEuampoyrACE3vzDw8OCV7XBY7h69YqsWFEje/fuiSH//fd30mtIhsdtEnjACOzbty+2Zs0aPStMM1iyZIngOQfEEu7cueN7tp7ugyn17LPPxrq7u2XLli3y9ttvS0tLi1y8eNGpvK2tVSwBscY3B2TXrl0UCAOOaxK4zwQwUxEC0N3dI0899ZQUFRU5HzzSkJubq3HDjo6OhG6DOe2UooAC69atiw0ODgqepMQchoaGBmtK5JAMDw/puqvrphw/ftzU5axn8uWvM/l6uAe1Liu0IzPHLBp1obFFgdlEdvb12X/t8ewC4gPmU1Zmz1BE/uLFS6y5R4X6egTMS8CS3GXQzPGvtKKAMtaNpF2J/Px8+fHHH2Xjxo2WAnXrDCiIRWNjo1Pf0NCg1NfXO9v+jd2/0frfsNMte2+OD26X/+9P5nj7GriQatKvXv+8yRzvLWs7gN6bb/q/5Ven9/c1x+fm9zsvv7yZOR61oG1P77r5nV/QvNR2XLt2FTtlzZq16gHk5uboOicnV9d4JQJGE3fs2KGzllE2nSBg/4SigEJYCgoKYpgKif7J9u3bZfPmzSoMGJnAYroWujH+5b3w2GGDmGy5IHX9nWXUEo8pnoyUDTq9/UHq0TNwV+PzW1Mro0d5TsGT4fN797eM97y95+Mt42X0d5fx/l6Q87bLIN6HBRMNq6uXWfdpvmRlZVtPPebrowpWgFG2bt2qZfA1kSCgTGBRQGEsa9eujZ07d07TeDnL6OgouhnOy1nMSaJA4k3qb6hWNP4V3fITs0nkOZvLz+Zz16vgbrIp0/G2PBl7g5WNt4UMnS6AbQwvwtvGvIOvv/5avv/+ez03vFkNkxKDiIEeYH1NWhTMgVbwIrZ+/XqNYOKBKkQysa6trTVFdG2dTMI2NpLzkrf9yvjlBTkuSJmp1v13H/cg2vIgntNUr8uDaMtE54R7EAu68RhZcE9Xto4NrjJai/01ZVFw1ZGQhFgkZFgbfoYllwmyzXrSUyKf6fGBy53MMN12un04E/d+dzp5X/L2ZMoigDg2NoY/ylMSAPx28vJ/YmPtu8gK8AkAAAAASUVORK5CYII=",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22710",
    "data-name": "Groupe 22710",
    transform: "translate(17.245 241.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22709",
    "data-name": "Groupe 22709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22707",
    "data-name": "Groupe 22707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3288",
    "data-name": "Rectangle 3288",
    d: "M.632,0H2.044a.633.633,0,0,1,.633.633V.772a.633.633,0,0,1-.633.633H.632A.632.632,0,0,1,0,.772V.632A.632.632,0,0,1,.632,0Z",
    fill: "#fff",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3289",
    "data-name": "Rectangle 3289",
    d: "M.613,0H1.992a.614.614,0,0,1,.614.614v.13a.613.613,0,0,1-.613.613H.613A.613.613,0,0,1,0,.744V.613A.613.613,0,0,1,.613,0Z",
    transform: "translate(0.032 0.015)",
    fill: "#f1f1f1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3290",
    "data-name": "Rectangle 3290",
    width: 2.534,
    height: 1.309,
    rx: 0.594,
    transform: "translate(0.063 0.031)",
    fill: "#e4e4e4",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3291",
    "data-name": "Rectangle 3291",
    width: 2.463,
    height: 1.262,
    rx: 0.575,
    transform: "translate(0.095 0.046)",
    fill: "#d6d6d6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3292",
    "data-name": "Rectangle 3292",
    d: "M.555,0h1.28a.556.556,0,0,1,.556.556v.1a.556.556,0,0,1-.556.556H.556A.556.556,0,0,1,0,.658v-.1A.555.555,0,0,1,.555,0Z",
    transform: "translate(0.126 0.061)",
    fill: "#c8c8c8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3293",
    "data-name": "Rectangle 3293",
    width: 2.32,
    height: 1.166,
    rx: 0.536,
    transform: "translate(0.158 0.076)",
    fill: "#bbb",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3294",
    "data-name": "Rectangle 3294",
    width: 2.249,
    height: 1.119,
    rx: 0.517,
    transform: "translate(0.189 0.092)",
    fill: "#adadad",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3295",
    "data-name": "Rectangle 3295",
    width: 2.177,
    height: 1.071,
    rx: 0.498,
    transform: "translate(0.221 0.107)",
    fill: "#a0a0a0",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3296",
    "data-name": "Rectangle 3296",
    width: 2.106,
    height: 1.023,
    rx: 0.479,
    transform: "translate(0.252 0.122)",
    fill: "#929292",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3297",
    "data-name": "Rectangle 3297",
    width: 2.034,
    height: 0.976,
    rx: 0.459,
    transform: "translate(0.284 0.138)",
    fill: "#848484",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3298",
    "data-name": "Rectangle 3298",
    width: 1.963,
    height: 0.928,
    rx: 0.44,
    transform: "translate(0.316 0.153)",
    fill: "#777",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3299",
    "data-name": "Rectangle 3299",
    width: 1.891,
    height: 0.88,
    rx: 0.421,
    transform: "translate(0.347 0.168)",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22708",
    "data-name": "Groupe 22708",
    transform: "translate(0.144 0.04)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3300",
    "data-name": "Rectangle 3300",
    width: 2.445,
    height: 1.175,
    rx: 0.553,
    fill: "#b74700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3301",
    "data-name": "Rectangle 3301",
    width: 2.431,
    height: 1.139,
    rx: 0.541,
    transform: "translate(0.007 0.003)",
    fill: "#b94a00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3302",
    "data-name": "Rectangle 3302",
    width: 2.416,
    height: 1.104,
    rx: 0.53,
    transform: "translate(0.015 0.006)",
    fill: "#bb4d00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3303",
    "data-name": "Rectangle 3303",
    width: 2.401,
    height: 1.068,
    rx: 0.518,
    transform: "translate(0.022 0.009)",
    fill: "#bc5000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3304",
    "data-name": "Rectangle 3304",
    width: 2.386,
    height: 1.033,
    rx: 0.507,
    transform: "translate(0.03 0.012)",
    fill: "#be5300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3305",
    "data-name": "Rectangle 3305",
    d: "M.5,0h1.38a.5.5,0,0,1,.5.5V.5a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,.5V.5A.5.5,0,0,1,.5,0Z",
    transform: "translate(0.037 0.015)",
    fill: "#c05600"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3306",
    "data-name": "Rectangle 3306",
    width: 2.356,
    height: 0.962,
    rx: 0.481,
    transform: "translate(0.045 0.018)",
    fill: "#c25900"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3307",
    "data-name": "Rectangle 3307",
    width: 2.341,
    height: 0.926,
    rx: 0.463,
    transform: "translate(0.052 0.021)",
    fill: "#c45c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3308",
    "data-name": "Rectangle 3308",
    width: 2.326,
    height: 0.89,
    rx: 0.445,
    transform: "translate(0.06 0.024)",
    fill: "#c55f00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3309",
    "data-name": "Rectangle 3309",
    width: 2.311,
    height: 0.855,
    rx: 0.427,
    transform: "translate(0.067 0.027)",
    fill: "#c76200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3310",
    "data-name": "Rectangle 3310",
    width: 2.296,
    height: 0.819,
    rx: 0.41,
    transform: "translate(0.075 0.03)",
    fill: "#c96500"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3311",
    "data-name": "Rectangle 3311",
    width: 2.281,
    height: 0.784,
    rx: 0.392,
    transform: "translate(0.082 0.033)",
    fill: "#cb6800"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3312",
    "data-name": "Rectangle 3312",
    width: 2.267,
    height: 0.748,
    rx: 0.374,
    transform: "translate(0.089 0.036)",
    fill: "#cd6b00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3313",
    "data-name": "Rectangle 3313",
    width: 2.252,
    height: 0.713,
    rx: 0.356,
    transform: "translate(0.097 0.039)",
    fill: "#cf6e00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3314",
    "data-name": "Rectangle 3314",
    width: 2.237,
    height: 0.677,
    rx: 0.339,
    transform: "translate(0.104 0.042)",
    fill: "#d07100"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3315",
    "data-name": "Rectangle 3315",
    width: 2.222,
    height: 0.642,
    rx: 0.321,
    transform: "translate(0.112 0.045)",
    fill: "#d27400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3316",
    "data-name": "Rectangle 3316",
    width: 2.207,
    height: 0.606,
    rx: 0.303,
    transform: "translate(0.119 0.048)",
    fill: "#d47700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3317",
    "data-name": "Rectangle 3317",
    width: 2.192,
    height: 0.571,
    rx: 0.285,
    transform: "translate(0.127 0.051)",
    fill: "#d67a00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3318",
    "data-name": "Rectangle 3318",
    width: 2.177,
    height: 0.535,
    rx: 0.268,
    transform: "translate(0.134 0.054)",
    fill: "#d87d00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3319",
    "data-name": "Rectangle 3319",
    width: 2.162,
    height: 0.5,
    rx: 0.25,
    transform: "translate(0.142 0.057)",
    fill: "#d98000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3320",
    "data-name": "Rectangle 3320",
    width: 2.147,
    height: 0.464,
    rx: 0.232,
    transform: "translate(0.149 0.06)",
    fill: "#db8300"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3321",
    "data-name": "Rectangle 3321",
    width: 2.132,
    height: 0.429,
    rx: 0.214,
    transform: "translate(0.157 0.063)",
    fill: "#dd8600"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5856",
    "data-name": "Trac\\xE9 5856",
    d: "M39.3,284.049a8.91,8.91,0,0,1-2.062.073c-.084-.1-.06-.2.192-.214A6.535,6.535,0,0,1,39.3,284.049Z",
    transform: "translate(-36.903 -283.806)",
    fill: "#fff",
    opacity: 0.5
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5857",
    "data-name": "Trac\\xE9 5857",
    d: "M180.023,227.169a.2.2,0,0,0-.2-.2H84.146c-1.875,0-2.157.116-2.368.323l1.2.371H179.82a.2.2,0,0,0,.2-.2Z",
    transform: "translate(-44.912 -10.305)",
    fill: "url(#linear-gradient-56)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22711",
    "data-name": "Groupe 22711",
    transform: "translate(19.444 216.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5858",
    "data-name": "Trac\\xE9 5858",
    d: "M56.866,228.931h1.659L43.817,244.043l-2.223.076Z",
    transform: "translate(-41.594 -228.34)",
    fill: "#637771"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5859",
    "data-name": "Trac\\xE9 5859",
    d: "M59.062,228.554l.991-.985h1.659l-15.289,15.7-.229.008,14.341-14.672Z",
    transform: "translate(-44.199 -227.569)",
    fill: "#232628"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22713",
    "data-name": "Groupe 22713",
    transform: "translate(53.584 208.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5862",
    "data-name": "Trac\\xE9 5862",
    d: "M120.669,258.91V209.289l-.332.026v49.6Z",
    transform: "translate(-120.337 -209.264)",
    fill: "url(#linear-gradient-57)",
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5863",
    "data-name": "Trac\\xE9 5863",
    d: "M121.435,258.888V209.232l-.332.025v49.621Z",
    transform: "translate(-120.771 -209.232)",
    fill: "url(#linear-gradient-58)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22714",
    "data-name": "Groupe 22714",
    transform: "translate(128.389 208.775)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3322",
    "data-name": "Rectangle 3322",
    width: 49.6,
    height: 0.332,
    transform: "translate(0 49.6) rotate(-90)",
    fill: "url(#linear-gradient-59)",
    style: {
      mixBlendMode: "hard-light",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5864",
    "data-name": "Trac\\xE9 5864",
    d: "M293.972,258.208V208.775h-.332v49.6Z",
    transform: "translate(-293.308 -208.775)",
    fill: "url(#linear-gradient-60)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22074",
    "data-name": "Groupe 22074",
    transform: "translate(79.546 24.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_93",
    "data-name": "Groupe 93",
    transform: "translate(0 18.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_67",
    "data-name": "Groupe 67",
    transform: "translate(8.839 6.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M1125.565,329.178a1.545,1.545,0,0,1-1,.343,1.346,1.346,0,0,1-1.466-1.462,1.456,1.456,0,0,1,1.5-1.466,1.337,1.337,0,0,1,.931.359.265.265,0,0,1-.355.392.862.862,0,0,0-.576-.257.974.974,0,0,0-.972.972.9.9,0,0,0,.935.972,1.04,1.04,0,0,0,.612-.184v-.5h-.612a.249.249,0,1,1,0-.5h.817a.28.28,0,0,1,.29.241v.87A.328.328,0,0,1,1125.565,329.178Z",
    transform: "translate(-1123.095 -326.564)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M1156.661,329.763a.272.272,0,0,1-.543.008v-2.32a.244.244,0,0,1,.245-.249h1.086a.907.907,0,0,1,.384,1.736l.543.661a.276.276,0,1,1-.458.306l-.617-.882h-.641Zm0-1.209h.788a.429.429,0,0,0,0-.858h-.788Z",
    transform: "translate(-1152.134 -327.1)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M1186.476,329.325a1.426,1.426,0,0,1-1.54-1.47,1.5,1.5,0,0,1,3,0A1.424,1.424,0,0,1,1186.476,329.325Zm-.045-2.438a.968.968,0,1,0,.972.968A.935.935,0,0,0,1186.431,326.887Z",
    transform: "translate(-1177.476 -326.356)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M1222.631,327.371a.268.268,0,1,1,.535,0v1.478a1.234,1.234,0,0,1-2.462,0v-1.478a.268.268,0,1,1,.535,0v1.478c0,.8,1.393.854,1.393,0Z",
    transform: "translate(-1208.929 -326.999)",
    fill: "#333234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M1252.64,327.18a.281.281,0,0,1,.278-.282h.943a1.021,1.021,0,0,1,0,2.042h-.682v.539a.257.257,0,0,1-.261.282.276.276,0,0,1-.278-.282Zm.539.233v1.017h.682a.509.509,0,0,0,0-1.017Z",
    transform: "translate(-1237.013 -326.833)",
    fill: "#333234"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_92",
    "data-name": "Groupe 92",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_70",
    "data-name": "Groupe 70",
    transform: "translate(7.052 0.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_69",
    "data-name": "Groupe 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_68",
    "data-name": "Groupe 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M1112.854,282.593h-1.464l-.6-.845h-2.509l.353-.8h1.586l-1.648-2.326h1.49Z",
    transform: "translate(-1108.284 -278.62)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_73",
    "data-name": "Groupe 73",
    transform: "translate(10.262 0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_72",
    "data-name": "Groupe 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_71",
    "data-name": "Groupe 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M1139.133,282.533H1137.7l-1.078-1.523.188-.024a1.628,1.628,0,0,0,.849-.341.617.617,0,0,0,.24-.45c0-.4-.525-.748-1.194-.8-.06,0-.122-.009-.185-.009h-1.026l-.036-.049-.561-.783.218,0h1.405c1.425,0,2.585.737,2.585,1.644a1.437,1.437,0,0,1-.781,1.178Z",
    transform: "translate(-1134.892 -278.551)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_76",
    "data-name": "Groupe 76",
    transform: "translate(21.408 0.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_75",
    "data-name": "Groupe 75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_74",
    "data-name": "Groupe 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M1228.663,279.494h-1.371v-.91h1.371Z",
    transform: "translate(-1227.292 -278.584)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_79",
    "data-name": "Groupe 79",
    transform: "translate(15.319 0.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_78",
    "data-name": "Groupe 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_77",
    "data-name": "Groupe 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M1181.792,282.565h-1.328l-2.365-2.414v2.414h-1.281v-3.981h1.29l2.4,2.466v-2.466h1.281Z",
    transform: "translate(-1176.818 -278.584)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_82",
    "data-name": "Groupe 82",
    transform: "translate(21.408 1.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_81",
    "data-name": "Groupe 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_80",
    "data-name": "Groupe 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M1228.663,293.057h-1.371v-2.542h1.371Z",
    transform: "translate(-1227.292 -290.515)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_85",
    "data-name": "Groupe 85",
    transform: "translate(23.798 0.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_84",
    "data-name": "Groupe 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_83",
    "data-name": "Groupe 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M1252.081,282.565H1250.8v-2.414l-2.364,2.414h-1.33v-3.981h1.281v2.467l2.4-2.467h1.292Z",
    transform: "translate(-1247.105 -278.584)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_88",
    "data-name": "Groupe 88",
    transform: "translate(29.709 0.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_87",
    "data-name": "Groupe 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_86",
    "data-name": "Groupe 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M1299.263,282.118a5.04,5.04,0,0,1-1.684-.257,2.311,2.311,0,0,1-1.1-.748,1.741,1.741,0,0,1-.371-1.07,1.679,1.679,0,0,1,.415-1.116,2.585,2.585,0,0,1,1.2-.736,4.793,4.793,0,0,1,1.476-.2,4.31,4.31,0,0,1,1.8.307,1.558,1.558,0,0,1,.839.828l.053.138-1.37.16-.036-.072a.845.845,0,0,0-.432-.383,2.022,2.022,0,0,0-.852-.159,2.181,2.181,0,0,0-1.234.309,1.007,1.007,0,0,0-.439.889,1.1,1.1,0,0,0,.449.96,2.089,2.089,0,0,0,1.222.327,3.186,3.186,0,0,0,.759-.094,3.421,3.421,0,0,0,.61-.2v-.358h-1.411v-.806h2.781v1.652l-.055.033a4.2,4.2,0,0,1-1.118.413A6.259,6.259,0,0,1,1299.263,282.118Z",
    transform: "translate(-1296.109 -277.996)",
    fill: "#333234"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_91",
    "data-name": "Groupe 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_90",
    "data-name": "Groupe 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_89",
    "data-name": "Groupe 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M1054.729,280.107h-1.689l.005-2.464-1.568,2.464h-1.65l0-1.784,1.364-2.529,0,2.648,1.6-2.31h1.617l0,2.219,1.213-2.219h1.348l-.188.25Z",
    transform: "translate(-1049.826 -275.794)",
    fill: "#333234"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_98",
    "data-name": "Groupe 98",
    transform: "translate(4.358 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_97",
    "data-name": "Groupe 97",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_94",
    "data-name": "Groupe 94",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M1094.045,122.516c-.607-1.261-.912-1.342-1.822-1.342h-6.274s7.426,13.043,7.865,13.651c.583.808,1.183.6,1.36.359.326-.451,1.6-2.731,2.312-4a1.918,1.918,0,0,0,.028-2.217C1097.209,128.285,1094.652,123.777,1094.045,122.516Z",
    transform: "translate(-1085.95 -121.174)",
    fill: "#b70715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_95",
    "data-name": "Groupe 95",
    transform: "translate(9.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M1174.6,121.165s-3.943,0-5.263,0c-1.466,0-1.691.627-1.244,1.545.6,1.238,6.442,11.126,7.183,12.189.542.776,1.177.767,1.48.281s1.719-3.411,2.1-4.136a1.861,1.861,0,0,0-.009-1.841C1178.394,128.291,1174.6,121.165,1174.6,121.165Z",
    transform: "translate(-1167.891 -121.164)",
    fill: "#b70715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_96",
    "data-name": "Groupe 96",
    transform: "translate(18.93 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M1243.913,121.174c-1.215,0-1.174.448-.846,1.051.34.628,2.2,3.551,2.719,4.476.557,1,1.158,1.285,1.53.668.47-.775,3.442-6.195,3.442-6.195Z",
    transform: "translate(-1242.87 -121.174)",
    fill: "#b70715"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamionVl);
export default __webpack_public_path__ + "static/media/camionVL.fbb657d0af9f3e4a56b759c94e97164b.svg";
export { ForwardRef as ReactComponent };